/*
 * FLEETA UI — 공유 섹션 동작 커스텀 엘리먼트.
 * 각 정의는 IIFE 가드 + class extends HTMLElement + customElements.define.
 * (interactions.md ↔ structure-map §G). 배치별로 요소를 추가한다.
 */

/* <fleeta-video> — YouTube facade.
   data-mode="modal": 클릭 시 공유 <fleeta-video-modal> 중앙 오버레이로 재생(반복 가능).
   기본(플래그 없음): 클릭 시 제자리 iframe 주입(1회 스왑) — 기존 인라인 동작. */
   (function () {
    if (customElements.get('fleeta-video')) return;
    class FleetaVideo extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.fleeta-video__btn');
        if (!this.btn) return;
        this.modalMode = this.getAttribute('data-mode') === 'modal';
        this._onClick = this._activate.bind(this);
        // 모달 모드: 반복 열기 위해 once 미사용 / 인라인 모드: 1회 스왑
        this.btn.addEventListener('click', this._onClick, this.modalMode ? false : { once: true });
      }
      disconnectedCallback() {
        if (this.btn && this._onClick) this.btn.removeEventListener('click', this._onClick);
      }
      _activate(e) {
        const id = this.getAttribute('data-id');
        if (!id) return;
        if (this.modalMode) {
          if (e) e.preventDefault();
          const modal = document.querySelector('fleeta-video-modal');
          if (modal && typeof modal.open === 'function') modal.open(id);
          return;
        }
        const label = this.btn.getAttribute('aria-label') || 'YouTube video';
        const iframe = document.createElement('iframe');
        iframe.className = 'fleeta-video__iframe';
        iframe.src =
          'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
        iframe.title = label;
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        );
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('loading', 'lazy');
        this.innerHTML = '';
        this.appendChild(iframe);
      }
    }
    customElements.define('fleeta-video', FleetaVideo);
  })();

  /* <fleeta-hero-video> — 배경 영상 자동재생 백스톱. React처럼 muted를 명령형으로 세팅 +
     play()를 호출해 Chrome 자동재생 차단(무음 프롭 타이밍)을 우회. */
  (function () {
    if (customElements.get('fleeta-hero-video')) return;
    class FleetaHeroVideo extends HTMLElement {
      connectedCallback() {
        var v = this.querySelector('video');
        if (!v) return;
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    customElements.define('fleeta-hero-video', FleetaHeroVideo);
  })();

  /* <fleeta-carousel> — 슬라이드 트랙 + autoplay/dots/prev-next (hero·features) */
  (function () {
    if (customElements.get('fleeta-carousel')) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    class FleetaCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-carousel-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-carousel-dot]'));
        if (!this.track || this.slides.length === 0) return;
        this.index = 0;
        this.busy = false;
        var prev = this.querySelector('[data-carousel-prev]');
        var next = this.querySelector('[data-carousel-next]');
        if (prev) prev.addEventListener('click', () => this._step(-1));
        if (next) next.addEventListener('click', () => this._step(1));
        this.dots.forEach((d, i) => d.addEventListener('click', () => this._go(i)));
        this._go(0);
        this._startAuto();
        this.addEventListener('mouseenter', () => this._stopAuto());
        this.addEventListener('mouseleave', () => this._startAuto());
      }
      disconnectedCallback() { this._stopAuto(); }
      _step(dir) { this._go((this.index + dir + this.slides.length) % this.slides.length); }
      _go(i) {
        if (this.busy) return;
        this.busy = true;
        this.index = i;
        this.track.style.transform = 'translateX(' + (-i * 100) + '%)';
        this.dots.forEach((d, di) => {
          var on = di === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        window.setTimeout(() => { this.busy = false; }, 550);
      }
      _startAuto() {
        var ms = parseInt(this.getAttribute('data-autoplay'), 10);
        if (reduce || !ms || this.slides.length < 2) return;
        this._stopAuto();
        this.timer = window.setInterval(() => this._step(1), ms);
      }
      _stopAuto() { if (this.timer) { window.clearInterval(this.timer); this.timer = null; } }
    }
    customElements.define('fleeta-carousel', FleetaCarousel);
  })();
  
  /* spec-group 컨트롤러 — <fleeta-tabs data-spec-link>의 'fleeta:spec-group' 이벤트를 받아
     [data-spec-group] 요소(fleeta-product-specs 'View full specifications' 인스턴스) 중 매칭 그룹만 노출.
     ⚠ FleetaTabs의 customElements.define 보다 앞에 리스너를 등록해야 초기 _activate(0) 디스패치를 잡음.
     탭 전환 시 이전 그룹의 <details> open 상태를 새 그룹에 복사(전체 스펙 펼친 채 전환 시 유지). */
  (function () {
    if (window.__fleetaSpecGroupBound) return;
    window.__fleetaSpecGroupBound = true;
    function apply(group) {
      var els = document.querySelectorAll('[data-spec-group]');
      if (!els.length) return;
      var wasOpen = false;
      els.forEach(function (el) {
        if (!el.hidden) {
          var d = el.querySelector('details.fleeta-pspecs__collapse');
          if (d && d.open) wasOpen = true;
        }
      });
      els.forEach(function (el) {
        var on = el.getAttribute('data-spec-group') === group;
        el.hidden = !on;
        if (on) {
          var d = el.querySelector('details.fleeta-pspecs__collapse');
          if (d) d.open = wasOpen;
        }
      });
    }
    document.addEventListener('fleeta:spec-group', function (e) {
      if (e.detail && e.detail.group) apply(e.detail.group);
    });
    // 테마 에디터: 숨겨진 그룹(예: LTE) 섹션/블록 선택 시 그 그룹을 드러내 편집 가능하게.
    if (window.Shopify && window.Shopify.designMode) {
      var reveal = function (t) {
        if (!t || !t.closest) return;
        var host = t.closest('[data-spec-group]');
        if (!host) {
          var sec = t.closest('.shopify-section');
          host = sec ? sec.querySelector('[data-spec-group]') : null;
        }
        if (host) apply(host.getAttribute('data-spec-group'));
      };
      document.addEventListener('shopify:section:select', function (e) { reveal(e.target); });
      document.addEventListener('shopify:block:select', function (e) { reveal(e.target); });
    }
  })();

  /* <fleeta-tabs> — 탭/패널 전환 (ARIA + 화살표 키).
     data-autoplay="<ms>"가 있으면 자동 회전(React ClientSection: 5초마다 다음 탭, 호버/포커스 시 정지 후
     이탈 시 현재 탭에서 재개). 디자인 모드·prefers-reduced-motion에선 자동 회전 비활성. 속성 없으면 기존 동작 그대로. */
  (function () {
    if (customElements.get('fleeta-tabs')) return;
    class FleetaTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-tab]'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-panel]'));
        if (this.tabs.length === 0) return;
        this.tabs.forEach((t, i) => {
          t.addEventListener('click', () => this._activate(i));
          t.addEventListener('keydown', (e) => this._key(e, i));
        });
        // opt-in: data-initial="<index>"로 첫 활성 탭 지정(Developers AskFourWays initialTab). 없으면 0.
        var init = parseInt(this.getAttribute('data-initial'), 10);
        this.selected = init >= 0 && init < this.tabs.length ? init : 0;
        this._activate(this.selected);
        this._setupAutoplay();
      }
      disconnectedCallback() { this._clearTimer(); }
      _activate(i) {
        this.selected = i;
        this.tabs.forEach((t, ti) => {
          var on = ti === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          t.classList.toggle('is-active', on);
        });
        this.panels.forEach((p, pi) => { p.hidden = pi !== i; });
        // opt-in: data-spec-link 있으면 활성 탭의 data-spec-key를 문서로 브로드캐스트 →
        // 외부 'View full specifications'(fleeta-product-specs, [data-spec-group]) 동기화. 없으면 무동작.
        if (this.hasAttribute('data-spec-link')) {
          var key = this.tabs[i].getAttribute('data-spec-key');
          if (key) document.dispatchEvent(new CustomEvent('fleeta:spec-group', { detail: { group: key } }));
        }
      }
      _key(e, i) {
        var n = this.tabs.length;
        if (e.key === 'ArrowRight') { e.preventDefault(); var r = (i + 1) % n; this.tabs[r].focus(); this._activate(r); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); var l = (i - 1 + n) % n; this.tabs[l].focus(); this._activate(l); }
        else if (e.key === 'Home') { e.preventDefault(); this.tabs[0].focus(); this._activate(0); }
        else if (e.key === 'End') { e.preventDefault(); this.tabs[n - 1].focus(); this._activate(n - 1); }
      }
      _setupAutoplay() {
        var ms = parseInt(this.getAttribute('data-autoplay'), 10);
        if (!ms || ms < 1000 || this.tabs.length < 2) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || (window.Shopify && window.Shopify.designMode)) return;
        this._autoMs = ms;
        this._paused = false;
        var self = this;
        var pause = function () { self._paused = true; self._clearTimer(); };
        var resume = function () { if (self.contains(document.activeElement)) return; self._paused = false; self._arm(); };
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this._arm();
      }
      _arm() {
        this._clearTimer();
        if (this._paused) return;
        var self = this;
        this._timer = window.setTimeout(function () {
          self._activate((self.selected + 1) % self.tabs.length);
          self._arm();
        }, this._autoMs);
      }
      _clearTimer() { if (this._timer) { window.clearTimeout(this._timer); this._timer = null; } }
    }
    customElements.define('fleeta-tabs', FleetaTabs);
  })();

  /* <fleeta-pdp-tabs> — 페이지 레벨 PDP 상단 탭(Overview/Spec/Recording/Package).
     형제 .shopify-section을 [data-pdp-section-tab] 마커로 매핑해 hidden 토글(자손만 보는 <fleeta-tabs>로는 불가).
     딥링크(#spec)·hashchange·화살표키·테마 에디터(select/block/load/reorder) 대응. 헤더 높이를 --fl-header-h로 측정. */
  (function () {
    if (customElements.get('fleeta-pdp-tabs')) return;
    class FleetaPdpTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-pdp-tab]'));
        if (!this.buttons.length) return;
        document.documentElement.classList.add('fleeta-pdp-ready'); // FOUC 방지 규칙 해제 → 이후 hidden 속성이 표시 제어
        this._buildMap();
        this._measureHeader();
        this._onHash = this._hashChange.bind(this);
        this._onResize = this._measureHeader.bind(this);
        this.buttons.forEach((b, i) => {
          b.addEventListener('click', () => this.activate(b.getAttribute('data-pdp-tab'), true));
          b.addEventListener('keydown', (e) => this._key(e, i));
        });
        window.addEventListener('hashchange', this._onHash);
        window.addEventListener('resize', this._onResize);
        var initial = (window.location.hash || '').replace('#', '');
        this.activate(this._has(initial) ? initial : this._firstTab(), false);
        if (window.Shopify && window.Shopify.designMode) {
          this._onSelect = (e) => this._editorReveal(e.target);
          this._onBlock = (e) => this._editorReveal(e.target && e.target.closest ? e.target.closest('.shopify-section') : null);
          this._onLoad = () => { this._buildMap(); this.activate(this.current, false); };
          document.addEventListener('shopify:section:select', this._onSelect);
          document.addEventListener('shopify:block:select', this._onBlock);
          document.addEventListener('shopify:section:load', this._onLoad);
          document.addEventListener('shopify:section:reorder', this._onLoad);
        }
      }
      disconnectedCallback() {
        window.removeEventListener('hashchange', this._onHash);
        window.removeEventListener('resize', this._onResize);
      }
      _buildMap() {
        this.map = {};
        var self = this;
        var push = function (tab, wrap) { (self.map[tab] = self.map[tab] || []).push(wrap); };
        // 탭 바 다음의 형제 .shopify-section들을 순회: 마커 있으면 그 탭, 없으면 overview 기본.
        // (재사용 마케팅 섹션은 마커 없이도 자동 Overview 귀속 → 섹션 수정 불필요.)
        var barWrap = this.closest('.shopify-section');
        if (barWrap && barWrap.parentElement) {
          var sib = barWrap.nextElementSibling;
          while (sib) {
            if (sib.classList && sib.classList.contains('shopify-section')) {
              var marker = sib.querySelector('[data-pdp-section-tab]');
              push(marker ? marker.getAttribute('data-pdp-section-tab') : 'overview', sib);
            }
            sib = sib.nextElementSibling;
          }
        } else {
          document.querySelectorAll('[data-pdp-section-tab]').forEach(function (m) {
            var w = m.closest('.shopify-section');
            if (w) push(m.getAttribute('data-pdp-section-tab'), w);
          });
        }
        // 매핑된 섹션이 없는 탭 버튼은 숨김.
        this.buttons.forEach(function (b) {
          var t = b.getAttribute('data-pdp-tab');
          b.hidden = !(self.map[t] && self.map[t].length);
        });
      }
      _has(tab) { return !!(tab && this.map && this.map[tab] && this.map[tab].length); }
      _firstTab() {
        var t = this.buttons[0] ? this.buttons[0].getAttribute('data-pdp-tab') : 'overview';
        return this._has(t) ? t : (Object.keys(this.map)[0] || t);
      }
      activate(tab, push) {
        if (!this._has(tab)) tab = this._firstTab();
        this.current = tab;
        this.buttons.forEach(function (b) {
          var on = b.getAttribute('data-pdp-tab') === tab;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        var map = this.map;
        Object.keys(map).forEach(function (t) {
          map[t].forEach(function (w) { w.hidden = t !== tab; });
        });
        if (push && window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + tab);
        }
        document.dispatchEvent(new CustomEvent('fleeta:pdp:tab', { detail: { tab: tab } }));
      }
      _hashChange() {
        var h = (window.location.hash || '').replace('#', '');
        if (this._has(h)) this.activate(h, false);
      }
      _editorReveal(wrap) {
        if (!wrap) return;
        var self = this, found = null;
        Object.keys(this.map).forEach(function (t) {
          if (self.map[t].indexOf(wrap) > -1) found = t;
        });
        if (found) this.activate(found, false);
      }
      _key(e, i) {
        var n = this.buttons.length, t;
        if (e.key === 'ArrowRight') t = (i + 1) % n;
        else if (e.key === 'ArrowLeft') t = (i - 1 + n) % n;
        else return;
        e.preventDefault();
        this.buttons[t].focus();
        this.activate(this.buttons[t].getAttribute('data-pdp-tab'), true);
      }
      _measureHeader() {
        var hdr = document.querySelector('.fleeta-header-section');
        var h = 0;
        if (hdr) {
          var pos = window.getComputedStyle(hdr).position;
          if (pos === 'sticky' || pos === 'fixed') h = hdr.offsetHeight;
        }
        document.documentElement.style.setProperty('--fl-header-h', h + 'px');
      }
    }
    customElements.define('fleeta-pdp-tabs', FleetaPdpTabs);
  })();

  /* <fleeta-scrollspy> — page PDP 상단 sticky 탭바(스크롤 이동형).
     <fleeta-pdp-tabs>(show/hide)와 달리 탭 클릭 시 대상 섹션으로 부드럽게 스크롤하고,
     수동 스크롤 위치에 따라 활성 탭을 갱신(scroll-position spy). 탭이 없는 사이 섹션은
     "probe line 위 마지막 탭-대상"에 자동 귀속(Overview가 included+detail 내내 활성).
     대상 = #shopify-section-<key>(정적 JSON 섹션 래퍼) → 재사용 섹션 무수정.
     헤더 높이는 자체적으로 --fl-header-h로 측정(이 페이지엔 <fleeta-pdp-tabs> 없음). */
  (function () {
    if (customElements.get('fleeta-scrollspy')) return;
    var slice = function (n) { return Array.prototype.slice.call(n); };
    class FleetaScrollspy extends HTMLElement {
      connectedCallback() {
        document.documentElement.classList.add('fleeta-pdp-ready'); // FOUC 하드하이드 규칙 해제(보험)
        this.headerH = 0;
        this.navH = 0;
        this.wrap = this.closest('.shopify-section') || this; // sticky·.is-stuck는 섹션 래퍼에 적용
        var self = this;
        this._resolve();
        if (!this.tabs || !this.tabs.length) return;
        this._onScroll = function () {
          if (self._raf) return;
          self._raf = requestAnimationFrame(function () { self._raf = 0; self._tick(); });
        };
        this._onResize = function () { self._syncStuck(); self._measure(); self._applyOffsets(); self._spy(); };
        this._onHash = function () { self._gotoHash(false); };
        this._onClick = function (e) {
          var t = e.target && e.target.closest ? e.target.closest('[data-target]') : null;
          if (!t || !self.contains(t)) return;
          var el = document.getElementById(t.getAttribute('data-target'));
          if (!el) return; // 대상 없으면 기본 앵커 동작에 맡김
          e.preventDefault();
          self._scrollTo({ tab: t, el: el });
          var key = t.getAttribute('data-key') || t.getAttribute('data-target');
          if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#' + key);
        };
        this.addEventListener('click', this._onClick);
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize);
        window.addEventListener('hashchange', this._onHash);
        // 초기: 해시가 있으면 폰트/레이아웃 안정 후 이동, 없으면 현재 위치로 spy.
        if (!this._gotoHash(true)) this._spy();
        this._syncStuck();
        if (window.Shopify && window.Shopify.designMode) {
          this._onEditor = function () { self._resolve(); self._spy(); };
          document.addEventListener('shopify:section:load', this._onEditor);
          document.addEventListener('shopify:section:reorder', this._onEditor);
          this._onEditorSelect = function (e) {
            var w = e.target && e.target.closest ? e.target.closest('.shopify-section') : null;
            if (!w) return;
            var a = self.anchors.filter(function (x) { return x.el === w; })[0];
            if (a) self._scrollTo(a);
          };
          document.addEventListener('shopify:section:select', this._onEditorSelect);
        }
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
        window.removeEventListener('hashchange', this._onHash);
      }
      _resolve() {
        this.tabs = slice(this.querySelectorAll('[data-target]'));
        this._measure();
        var self = this;
        this.anchors = [];
        this.tabs.forEach(function (t) {
          var key = t.getAttribute('data-target');
          // JSON 템플릿 섹션 래퍼 id = shopify-section-template--<pageid>__<key> → suffix 매칭.
          // (섹션그룹은 shopify-section-<key>, 예외적으로 정확 id도 지원.)
          var el = document.getElementById(key)
                || document.getElementById('shopify-section-' + key)
                || document.querySelector('.shopify-section[id$="__' + key + '"]');
          if (el) self.anchors.push({ tab: t, el: el });
        });
        // 시각(문서) 순서로 정렬 — 에디터 재정렬에도 spy가 정확.
        this.anchors.sort(function (a, b) {
          return a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top;
        });
        this._applyOffsets();
      }
      _measure() {
        var hdr = document.querySelector('.fleeta-header-section');
        var h = 0;
        if (hdr) {
          var pos = window.getComputedStyle(hdr).position;
          if (pos === 'sticky' || pos === 'fixed') h = hdr.offsetHeight;
        }
        this.headerH = h;
        document.documentElement.style.setProperty('--fl-header-h', h + 'px');
        // navH = 섹션 래퍼 높이(.is-stuck 시 pill 상하 인셋 포함) → scroll-margin이 stuck 상태를 반영.
        this.navH = (this.wrap || this).offsetHeight || 0;
      }
      _syncStuck() {
        // 래퍼가 sticky top(=headerH)에 붙었는지 판정 → 헤더처럼 둥근 pill(.is-stuck) 토글.
        if (!this.wrap) return;
        var stuck = this.wrap.getBoundingClientRect().top <= this.headerH + 1;
        this.wrap.classList.toggle('is-stuck', stuck);
      }
      _offset() { return this.headerH + this.navH; }
      _applyOffsets() {
        var off = this._offset();
        (this.anchors || []).forEach(function (a) { a.el.style.scrollMarginTop = off + 'px'; });
      }
      _tick() {
        // 헤더가 스크롤 시 접혀 높이가 변함(유틸바 축소) → 재측정해 nav top(--fl-header-h)과
        // 스크롤 오프셋(scroll-margin)을 최신화. 값이 바뀔 때만 offset 재적용.
        this._syncStuck(); // stuck 토글이 래퍼 높이(navH)를 바꾸므로 측정 전에 실행.
        var prevH = this.headerH, prevNav = this.navH;
        this._measure();
        if (this.headerH !== prevH || this.navH !== prevNav) this._applyOffsets();
        this._spy();
      }
      _spy() {
        if (this._lock || !this.anchors || !this.anchors.length) return;
        var line = this._offset() + 2;
        var active = this.anchors[0];
        for (var i = 0; i < this.anchors.length; i++) {
          if (this.anchors[i].el.getBoundingClientRect().top <= line) active = this.anchors[i];
          else break;
        }
        if (active) this._setActive(active.tab);
      }
      _setActive(tabEl) {
        if (this._activeTab === tabEl) return;
        this._activeTab = tabEl;
        this.tabs.forEach(function (t) {
          var on = t === tabEl;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }
      _scrollTo(anchor) {
        if (!anchor || !anchor.el) return;
        var top = anchor.el.getBoundingClientRect().top + window.pageYOffset - this._offset();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this._lock = true;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        this._setActive(anchor.tab);
        var self = this;
        clearTimeout(this._lockT);
        this._lockT = setTimeout(function () { self._lock = false; }, 700);
      }
      _matchHash(hash) {
        if (!hash || !this.anchors) return null;
        return this.anchors.filter(function (a) {
          return a.tab.getAttribute('data-key') === hash || a.tab.getAttribute('data-target') === hash;
        })[0] || null;
      }
      _gotoHash(deferred) {
        var hash = (window.location.hash || '').replace('#', '');
        var match = this._matchHash(hash);
        if (!match) return false;
        var self = this;
        if (deferred) {
          requestAnimationFrame(function () { setTimeout(function () { self._scrollTo(match); }, 50); });
        } else {
          this._scrollTo(match);
        }
        return true;
      }
    }
    customElements.define('fleeta-scrollspy', FleetaScrollspy);
  })();

  /* FLEETA.fleetStats() — 공유 라이브 통계 (React src/lib/fleetStats.ts 계약).
     GET {supabaseUrl}/functions/v1/fleet-stats → { users, dashcams }. 설정은 window.FLEETA_FORMS(폼과 공유).
     세션당 1회만 요청 — 처음 받아온 값을 sessionStorage에 고정해 페이지 이동/새로고침에도 재요청 없이 동일 값 표시(탭 닫으면 초기화 → 다음 방문 시 최신값 재조회). 헤더 pill + <fleeta-countup>가 공유. 항상 resolve, 실패 시 {users:0,dashcams:0}. */
  (function () {
    var NS = (window.FLEETA = window.FLEETA || {});
    if (NS.fleetStats) return;
    var cached = null;
    var SKEY = 'fleeta_fleet_stats';   // 세션 캐시 키 (탭 세션 동안 값 고정)
    function readSession() {
      try {
        var raw = window.sessionStorage.getItem(SKEY);
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (v && typeof v.users === 'number' && typeof v.dashcams === 'number') return v;
      } catch (e) {}   // Safari 프라이빗 모드 등 저장소 차단 → 기존 매-페이지 fetch로 폴백
      return null;
    }
    function writeSession(v) {
      try { window.sessionStorage.setItem(SKEY, JSON.stringify(v)); } catch (e) {}
    }
    NS.fleetStats = function () {
      if (cached) return cached;
      // 이번 세션에 이미 받아온 값이면 즉시 반환(재요청 없음).
      var stored = readSession();
      if (stored) { cached = Promise.resolve(stored); return cached; }
      var cfg = window.FLEETA_FORMS;
      var fallback = { users: 0, dashcams: 0 };
      if (!cfg || !cfg.supabaseUrl) { cached = Promise.resolve(fallback); return cached; }
      var url = cfg.supabaseUrl.replace(/\/$/, '') + '/functions/v1/fleet-stats';
      var headers = { 'Accept': 'application/json' };
      if (cfg.anonKey) { headers['Authorization'] = 'Bearer ' + cfg.anonKey; headers['apikey'] = cfg.anonKey; }
      cached = fetch(url, { method: 'GET', mode: 'cors', cache: 'no-store', headers: headers })
        .then(function (r) { if (!r.ok) throw new Error('fleet-stats ' + r.status); return r.json(); })
        .then(function (d) {
          var s = {
            users: (d && typeof d.users === 'number') ? d.users : 0,
            dashcams: (d && typeof d.dashcams === 'number') ? d.dashcams : 0
          };
          // 실제 값을 받았을 때만 세션에 고정(0/실패는 저장 안 함 → 다음 페이지에서 재시도).
          if (s.dashcams > 0) writeSession(s);
          return s;
        })
        .catch(function (e) { if (window.console) console.error('Failed to fetch fleet stats:', e); return fallback; });
      return cached;
    };
  })();
  
  /* <fleeta-countup> — 뷰포트 진입 시 숫자 카운트업.
     자식 [data-countup] span이 data-stat-key(users|dashcams)를 가지면 라이브 바인딩:
     FLEETA.fleetStats() 응답 대기 중 숫자를 계속 굴리고(rolling 로더, React FleetStats의 로딩 대체),
     resolve되면 실제 값으로 감속·안착. 실패 시 0(원본 동일). 비바인딩 span은 정적 target으로 카운트업. */
  (function () {
    if (customElements.get('fleeta-countup')) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    class FleetaCountup extends HTMLElement {
      connectedCallback() {
        this.nums = Array.prototype.slice.call(this.querySelectorAll('[data-countup]'));
        if (this.nums.length === 0) return;
        // 라이브 바인딩 span이 있으면 즉시 stats 요청 → resolve 시 target 반영.
        var bound = this.nums.filter((n) => n.hasAttribute('data-stat-key'));
        var self = this;
        this.live = bound.length > 0;
        this.resolved = !this.live;   // 라이브 없으면 대기 불필요
        this.ready = null;
        if (this.live && window.FLEETA && window.FLEETA.fleetStats) {
          this.ready = window.FLEETA.fleetStats().then((s) => {
            bound.forEach((n) => { n.setAttribute('data-countup', String((s && s[n.getAttribute('data-stat-key')]) || 0)); });
            self.resolved = true;
          });
        } else {
          this.resolved = true;   // fleetStats 미가용 → 정적 값
        }
        if (reduce || !('IntersectionObserver' in window)) {
          this._whenReady(() => self.nums.forEach((n) => self._set(n, self._target(n))));
          return;
        }
        this.obs = new IntersectionObserver((entries) => {
          entries.forEach((en) => { if (en.isIntersecting) { self.obs.disconnect(); self._begin(); } });
        }, { threshold: 0.4 });
        this.obs.observe(this);
      }
      disconnectedCallback() {
        if (this.obs) this.obs.disconnect();
        this._rolling = false;
        if (this._raf) window.cancelAnimationFrame(this._raf);
        if (this._rollTimeout) window.clearTimeout(this._rollTimeout);
      }
      _whenReady(cb) { if (this.ready) { this.ready.then(cb); } else { cb(); } }
      _target(n) { return parseFloat(n.getAttribute('data-countup')) || 0; }
      _set(n, v) { n.textContent = Math.round(v).toLocaleString(); }
      _read(n) { return parseFloat((n.textContent || '0').replace(/,/g, '')) || 0; }
      _rollCap(n) {
        if (n.hasAttribute('data-stat-key')) return 10000;         // 라이브: 4자리 스핀
        var t = Math.max(1, Math.round(this._target(n)));
        return Math.pow(10, String(t).length);                     // 고정: 자릿수 매칭 (90→100, 20→100)
      }
      _begin() {
        var self = this;
        // 라이브 응답이 아직이면 숫자를 계속 굴린다(rolling). resolve 시 실제 값으로 안착.
        if (this.live && !this.resolved && this.ready && !reduce) {
          this._startRoll();
          var settled = false;
          var settle = function () { if (settled) return; settled = true; self._settle(); };
          this.ready.then(settle);
          this._rollTimeout = window.setTimeout(settle, 8000);   // 안전장치: 응답 지연에도 안착
        } else {
          // 이미 resolve됐거나 라이브 없음 → 0에서 목표까지 카운트업(React count-up 1600ms).
          this._whenReady(function () { self._settle(0, 1600); });
        }
      }
      _startRoll() {
        var self = this;
        var caps = this.nums.map((n) => self._rollCap(n));
        // 셀마다 속도·위상을 달리해 인접 숫자가 같은 값으로 동기화돼 보이지 않게 한다.
        var speeds = caps.map((c, i) => c / (0.55 + 0.13 * i));   // ≈0.55~1초에 한 바퀴
        var phases = caps.map((c, i) => c * ((i * 0.41) % 1));    // 시작 오프셋
        var start = null;
        this._rolling = true;
        function frame(ts) {
          if (!self._rolling) return;
          if (start === null) start = ts;
          var elapsed = (ts - start) / 1000;
          for (var i = 0; i < self.nums.length; i++) {
            self._set(self.nums[i], (phases[i] + elapsed * speeds[i]) % caps[i]);
          }
          self._raf = window.requestAnimationFrame(frame);
        }
        this._raf = window.requestAnimationFrame(frame);
      }
      _settle(forceFrom, dur) {
        this._rolling = false;
        if (this._rollTimeout) { window.clearTimeout(this._rollTimeout); this._rollTimeout = null; }
        var self = this, duration = dur || 700;
        // 롤링 중이면 현재 표시값에서, 아니면 0에서 목표로 감속(easeOutCubic) → 릴이 안착하는 느낌.
        var from = this.nums.map((n) => (forceFrom === 0 ? 0 : self._read(n)));
        var start = null;
        function frame(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var e = 1 - Math.pow(1 - p, 3);
          for (var i = 0; i < self.nums.length; i++) {
            var to = self._target(self.nums[i]);
            self._set(self.nums[i], from[i] + (to - from[i]) * e);
          }
          if (p < 1) self._raf = window.requestAnimationFrame(frame);
        }
        this._raf = window.requestAnimationFrame(frame);
      }
    }
    customElements.define('fleeta-countup', FleetaCountup);
  })();
  
  /* <fleeta-dashcam-count> — 헤더 라이브 대시캠 수 (최신 원본 DashcamCounter.tsx).
     FLEETA.fleetStats() 공유 호출. 값이 오기 전에는 숫자와 같은 폭(36px)의 스켈레톤 막대를 보여주므로
     로딩→숫자 전환에 폭 변동이 없다(헤더는 좌우 여유가 거의 없어 폭이 흔들리면 CTA가 pill 밖으로 밀린다).
     0 = 조회 실패(fleetStats는 절대 reject하지 않고 {dashcams:0}로 폴백)이므로 원본처럼 pill을 숨긴다 —
     '0'을 실제 대수인 양 보여주거나 스켈레톤을 영원히 남기는 것보다 낫다.
     fleetStats에는 타임아웃이 없어 요청이 멈추면 영영 resolve되지 않으므로 STALL_MS 후 실패로 처리한다. */
  (function () {
    if (customElements.get('fleeta-dashcam-count')) return;
    var STALL_MS = 8000;
    class FleetaDashcamCount extends HTMLElement {
      connectedCallback() {
        this.out = this.querySelector('[data-count]');
        this.skeleton = this.querySelector('[data-count-loading]');
        if (!this.out || !(window.FLEETA && window.FLEETA.fleetStats)) return;
        var self = this;
        var settled = false;
        var stall = window.setTimeout(function () { self._settle(0); }, STALL_MS);
        window.FLEETA.fleetStats().then(function (s) {
          window.clearTimeout(stall);
          self._settle((s && typeof s.dashcams === 'number') ? s.dashcams : 0);
        });
        this._settle = function (n) {
          if (settled) return;
          settled = true;
          if (!(n > 0)) { self.hidden = true; return; }   // 조회 실패 → pill 자체를 숨김
          self.out.textContent = n.toLocaleString();
          self.out.hidden = false;
          if (self.skeleton) self.skeleton.hidden = true;
        };
      }
    }
    customElements.define('fleeta-dashcam-count', FleetaDashcamCount);
  })();
  
  /* <fleeta-stats-loader> 제거됨 — 정적 스켈레톤 대신 <fleeta-countup> 롤링 로더가 로딩 상태를 표현 */

  /* <fleeta-modal> — 진입 팝업(localStorage 디스미스). 다중 팝업은 순차 큐로 하나씩 노출 */
  (function () {
    if (customElements.get('fleeta-modal')) return;
    // 순차 큐 — 여러 .fleeta-popup을 DOM(블록) 순서대로 하나씩 오픈. 닫히면 다음 eligible 팝업으로 진행.
    var queue = {
      items: [],
      scheduled: false,
      active: null,
      register: function (m) {
        this.items.push(m);
        if (!this.scheduled) {
          this.scheduled = true;
          window.setTimeout(this.advance.bind(this), 400);
        }
      },
      advance: function () {
        if (this.active) return; // 이미 하나 열려 있으면 대기(close → release 때 재진행)
        while (this.items.length) {
          var m = this.items.shift();
          if (m.isConnected && !m._dismissed()) {
            this.active = m;
            m.open();
            return;
          }
        }
      },
      release: function (m) {
        if (this.active === m) this.active = null;
        this.advance();
      }
    };
    class FleetaModal extends HTMLElement {
      connectedCallback() {
        this.key = this.getAttribute('data-dismiss-key') || 'fleeta-popup';
        if (this._dismissed()) return;
        this._onKey = (e) => { if (e.key === 'Escape') this.close(); };
        this.querySelectorAll('[data-modal-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        var backdrop = this.querySelector('[data-modal-backdrop]');
        if (backdrop) backdrop.addEventListener('click', () => this.close());
        this.checkbox = this.querySelector('[data-modal-remember]');
        queue.register(this);
      }
      disconnectedCallback() { document.removeEventListener('keydown', this._onKey); }
      _dismissed() {
        try {
          var v = window.localStorage.getItem(this.key);
          if (!v) return false;
          return v === 'always' || v === new Date().toDateString();
        } catch (e) { return false; }
      }
      open() {
        this.hidden = false;
        document.documentElement.classList.add('fleeta-no-scroll');
        document.addEventListener('keydown', this._onKey);
        // 초기 포커스는 다이얼로그 래퍼(tabindex=-1)로 이동 — 스크린리더가 dialog 이름/role을 안내하되
        // 상호작용 컨트롤에 전역 *:focus-visible 링이 뜨지 않게 한다. 래퍼가 없으면 기존 동작으로 폴백.
        var f = this.querySelector('[data-modal-dialog]') || this.querySelector('[data-modal-close], a, button');
        if (f) f.focus();
      }
      close() {
        this.hidden = true;
        document.documentElement.classList.remove('fleeta-no-scroll');
        document.removeEventListener('keydown', this._onKey);
        if (this.checkbox && this.checkbox.checked) {
          try { window.localStorage.setItem(this.key, new Date().toDateString()); } catch (e) {}
        }
        queue.release(this); // 다음 eligible 팝업 노출
      }
    }
    customElements.define('fleeta-modal', FleetaModal);
  })();

  /* <fleeta-quick-demo-modal> — 스크롤 자동 오픈 퀵 데모 모달(React SetupGuideSimpleSection +
     DemoScheduleModal). data-qd-observe 대상이 뷰 진입 시 방문당 1회 오픈, 진입 랜딩 팝업과 중복 방지. */
  (function () {
    if (customElements.get('fleeta-quick-demo-modal')) return;
    class FleetaQuickDemoModal extends HTMLElement {
      connectedCallback() {
        this._onKey = (e) => { if (e.key === 'Escape') this.close(); };
        this.querySelectorAll('[data-qd-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        if (this._shown()) return;
        if (window.Shopify && window.Shopify.designMode) return; // 에디터에서는 자동 오픈 안 함
        var sel = this.getAttribute('data-qd-observe');
        var target = sel ? document.querySelector(sel) : null;
        if (!target) return;
        var self = this;
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) self._maybeOpen(); });
        }, { threshold: 0 });
        this._io.observe(target);
      }
      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        document.removeEventListener('keydown', this._onKey);
      }
      _shown() { try { return window.sessionStorage.getItem('fleeta_qd_shown') === '1'; } catch (e) { return false; } }
      _markShown() { try { window.sessionStorage.setItem('fleeta_qd_shown', '1'); } catch (e) {} }
      _otherPopupOpen() {
        return document.documentElement.classList.contains('fleeta-no-scroll')
          || !!document.querySelector('fleeta-modal.fleeta-popup:not([hidden])');
      }
      _maybeOpen() {
        if (this._shown()) { if (this._io) this._io.disconnect(); return; }
        if (this._otherPopupOpen()) return; // 다른 팝업 노출 중 → 다음 교차 때 재시도
        this.open();
      }
      open() {
        this._markShown();
        if (this._io) this._io.disconnect();
        this.hidden = false;
        // 스크롤 잠금 안 함 — React DemoScheduleModal은 body overflow를 건드리지 않아
        // 딤 backdrop 뒤로 페이지가 계속 스크롤된다. (_otherPopupOpen의 fleeta-no-scroll 감지는 랜딩 팝업용으로 유지)
        document.addEventListener('keydown', this._onKey);
      }
      close() {
        this.hidden = true;
        document.removeEventListener('keydown', this._onKey);
      }
    }
    customElements.define('fleeta-quick-demo-modal', FleetaQuickDemoModal);
  })();

  /* <fleeta-cards-carousel> — 페이지 단위 카드 캐러셀: 데스크톱 3/모바일 1 per page.
     React FeaturesCarouselBlock 재현(양옆 화살표 + 아래 페이지 도트, gap 정확 이동). */
  (function () {
    if (customElements.get('fleeta-cards-carousel')) return;
    class FleetaCardsCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-fcards-viewport]');
        this.track = this.querySelector('[data-fcards-track]');
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-fcards-card]'));
        this.dotsWrap = this.querySelector('[data-fcards-dots]');
        if (!this.viewport || !this.track || this.cards.length === 0) return;
        this.page = 0;
        this.mq = window.matchMedia('(min-width: 768px)');
        var prev = this.querySelector('[data-fcards-prev]');
        var next = this.querySelector('[data-fcards-next]');
        if (prev) prev.addEventListener('click', () => this._step(-1));
        if (next) next.addEventListener('click', () => this._step(1));
        this._onResize = this._layout.bind(this);
        this.mq.addEventListener('change', this._onResize);
        window.addEventListener('resize', this._onResize);
        this._sx = 0;
        this.addEventListener('touchstart', (e) => { this._sx = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          var dx = e.changedTouches[0].clientX - this._sx;
          if (dx < -50) this._step(1); else if (dx > 50) this._step(-1);
        }, { passive: true });
        this._layout();
      }
      disconnectedCallback() {
        if (this.mq && this._onResize) this.mq.removeEventListener('change', this._onResize);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      }
      get _gap() { return this.mq.matches ? 8 : 0; } /* md:gap-2 = 8px (모바일 1장 → 무관) */
      _layout() {
        this.perPage = this.mq.matches ? 3 : 1;
        this.totalPages = Math.max(1, Math.ceil(this.cards.length / this.perPage));
        if (this.page >= this.totalPages) this.page = this.totalPages - 1;
        var vw = this.viewport.clientWidth;
        var gap = this._gap;
        var cardW = (vw - (this.perPage - 1) * gap) / this.perPage;
        this.track.style.columnGap = gap + 'px';
        this.cards.forEach((c) => { c.style.flex = '0 0 ' + cardW + 'px'; c.style.maxWidth = cardW + 'px'; });
        this._buildDots();
        this._apply();
      }
      _buildDots() {
        if (!this.dotsWrap) return;
        this.dotsWrap.innerHTML = '';
        for (var i = 0; i < this.totalPages; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'fcards__dot';
          b.setAttribute('aria-label', 'Page ' + (i + 1));
          (function (idx, self) { b.addEventListener('click', function () { self._go(idx); }); })(i, this);
          this.dotsWrap.appendChild(b);
        }
        this.dotsWrap.hidden = this.totalPages < 2;
      }
      _step(dir) { this._go((this.page + dir + this.totalPages) % this.totalPages); }
      _go(i) { this.page = i; this._apply(); }
      _apply() {
        var vw = this.viewport.clientWidth;
        var offset = this.page * (vw + this._gap);
        this.track.style.transform = 'translateX(' + (-offset) + 'px)';
        if (this.dotsWrap) {
          Array.prototype.forEach.call(this.dotsWrap.children, (d, di) => {
            d.classList.toggle('is-active', di === this.page);
            d.setAttribute('aria-current', di === this.page ? 'true' : 'false');
          });
        }
      }
    }
    customElements.define('fleeta-cards-carousel', FleetaCardsCarousel);
  })();

  /* <fleeta-features-carousel> — 자유 스크롤 카드 캐러셀 + 진행바 thumb + 퀵점프 pill.
     React FeaturesSectionBlock(sync/goTo/goByOffset) 재현. 네이티브 overflow-x 스크롤 사용. */
  (function () {
    if (customElements.get('fleeta-features-carousel')) return;
    var GAP = 24; /* gap-6 = 24px */
    class FleetaFeaturesCarousel extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-fsec-scroller]');
        this.thumb = this.querySelector('[data-fsec-thumb]');
        if (!this.scroller) return;
        this.cards = Array.prototype.slice.call(this.scroller.children);
        this.prevBtn = this.querySelector('[data-fsec-prev]');
        this.nextBtn = this.querySelector('[data-fsec-next]');
        this._sync = this._sync.bind(this);
        this.scroller.addEventListener('scroll', this._sync, { passive: true });
        window.addEventListener('resize', this._sync);
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._byOffset(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._byOffset(1));
        /* 퀵점프 pill: 같은 섹션(.fleeta-fsec) 내 [data-fsec-jump] → 해당 카드로 스크롤 */
        var root = this.closest('.fleeta-fsec') || this.parentNode;
        var jumps = root ? Array.prototype.slice.call(root.querySelectorAll('[data-fsec-jump]')) : [];
        jumps.forEach((el) => {
          var i = parseInt(el.getAttribute('data-fsec-jump'), 10) || 0;
          el.addEventListener('click', () => this._goTo(i));
        });
        this._sync();
      }
      disconnectedCallback() {
        if (this.scroller) this.scroller.removeEventListener('scroll', this._sync);
        window.removeEventListener('resize', this._sync);
      }
      _step() {
        var first = this.cards[0];
        return first ? first.getBoundingClientRect().width + GAP : 364;
      }
      _sync() {
        var el = this.scroller;
        var max = el.scrollWidth - el.clientWidth;
        var p = max <= 2 ? 0 : Math.min(1, Math.max(0, el.scrollLeft / max));
        var vis = el.scrollWidth ? Math.min(1, el.clientWidth / el.scrollWidth) : 1;
        if (this.thumb) {
          this.thumb.style.width = (vis * 100) + '%';
          this.thumb.style.transform = 'translateX(' + (p * ((1 - vis) / (vis || 1)) * 100) + '%)';
        }
        if (this.prevBtn) this.prevBtn.disabled = p <= 0.01;
        if (this.nextBtn) this.nextBtn.disabled = max <= 2 || p >= 0.99;
      }
      _goTo(index) {
        var el = this.scroller;
        var to = Math.min(el.scrollWidth - el.clientWidth, Math.max(0, index) * this._step());
        el.scrollTo({ left: to, behavior: 'smooth' });
      }
      _byOffset(dir) {
        var el = this.scroller;
        var current = Math.round(el.scrollLeft / this._step());
        this._goTo(Math.min(this.cards.length - 1, Math.max(0, current + dir)));
      }
    }
    customElements.define('fleeta-features-carousel', FleetaFeaturesCarousel);
  })();

  /* <fleeta-cs-accordion> — 케이스 스터디 호버확장 이미지 아코디언(new-react-reference CaseStudySectionBlog).
     자동 회전(data-interval, 기본 2300ms), 호버/포커스/클릭 시 해당 타일 확장(.is-active). */
  (function () {
    if (customElements.get('fleeta-cs-accordion')) return;
    class FleetaCsAccordion extends HTMLElement {
      connectedCallback() {
        this.tiles = Array.prototype.slice.call(this.querySelectorAll('[data-cs-tile]'));
        if (this.tiles.length < 2) return;
        this.selected = 0;
        this.paused = false;
        this.interval = parseInt(this.getAttribute('data-interval'), 10) || 2300;
        var self = this;
        this.tiles.forEach(function (tile, i) {
          var pick = function () { self.paused = true; self._select(i); };
          tile.addEventListener('mouseenter', pick);
          tile.addEventListener('focusin', pick);
          tile.addEventListener('click', pick);
        });
        this._onLeave = function () { self.paused = false; };
        this.addEventListener('mouseleave', this._onLeave);
        this._select(0);
        if (!(window.Shopify && window.Shopify.designMode)) {
          this._timer = window.setInterval(function () {
            if (self.paused) return;
            self._select((self.selected + 1) % self.tiles.length);
          }, this.interval);
        }
      }
      disconnectedCallback() {
        if (this._timer) window.clearInterval(this._timer);
        if (this._onLeave) this.removeEventListener('mouseleave', this._onLeave);
      }
      _select(i) {
        this.selected = i;
        this.tiles.forEach(function (tile, idx) {
          var on = idx === i;
          tile.classList.toggle('is-active', on);
          tile.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
      }
    }
    customElements.define('fleeta-cs-accordion', FleetaCsAccordion);
  })();

  /* <fleeta-video-modal> — 중앙 오버레이 YouTube 팝업(Dashcams). 문서 내 [data-video-id] 클릭 위임 */
  (function () {
    if (customElements.get('fleeta-video-modal')) return;
    class FleetaVideoModal extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-vmodal-frame]');
        this._onKey = (e) => { if (e.key === 'Escape') this.close(); };
        this.querySelectorAll('[data-vmodal-close],[data-vmodal-backdrop]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );
        // document [data-video-id] 위임은 첫 인스턴스만 바인딩(중복 모달 렌더 시 이중 오픈 방지)
        if (!FleetaVideoModal._docBound) {
          FleetaVideoModal._docBound = true;
          this._ownsDoc = true;
          this._onDocClick = (e) => {
            var b = e.target.closest ? e.target.closest('[data-video-id]') : null;
            if (b && this.contains(b) === false) { e.preventDefault(); this.open(b.getAttribute('data-video-id')); }
          };
          document.addEventListener('click', this._onDocClick);
        }
      }
      disconnectedCallback() {
        if (this._ownsDoc) { document.removeEventListener('click', this._onDocClick); FleetaVideoModal._docBound = false; }
        document.removeEventListener('keydown', this._onKey);
      }
      open(id) {
        if (!id || !this.frame) return;
        var f = document.createElement('iframe');
        f.className = 'fleeta-vmodal__iframe';
        f.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
        f.title = 'YouTube video';
        f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        this.frame.innerHTML = '';
        this.frame.appendChild(f);
        this.hidden = false;
        document.documentElement.classList.add('fleeta-no-scroll');
        document.addEventListener('keydown', this._onKey);
        var c = this.querySelector('[data-vmodal-close]');
        if (c) c.focus();
      }
      close() {
        this.hidden = true;
        if (this.frame) this.frame.innerHTML = '';
        document.documentElement.classList.remove('fleeta-no-scroll');
        document.removeEventListener('keydown', this._onKey);
      }
    }
    customElements.define('fleeta-video-modal', FleetaVideoModal);
  })();
  
  /* <fleeta-pricing> — 월/연 토글 + 카메라 카운터 + 총액 재계산 (Pricing). 표 섹션과 CustomEvent로 동기화 */
  (function () {
    if (customElements.get('fleeta-pricing')) return;
    function round(n) { return Math.round(n); }
    class FleetaPricing extends HTMLElement {
      connectedCallback() {
        this.cycle = 'monthly';
        this.promo = this.getAttribute('data-promotion') === 'true';
        this.toggles = Array.prototype.slice.call(this.querySelectorAll('[data-billing-toggle]'));
        this.toggles.forEach((b) => b.addEventListener('click', () => this._setBilling(b.getAttribute('data-billing-toggle'))));
        this.querySelectorAll('[data-plan]').forEach((plan) => {
          var dec = plan.querySelector('[data-count-dec]');
          var inc = plan.querySelector('[data-count-inc]');
          var input = plan.querySelector('[data-count-input]');
          if (input) {
            if (dec) dec.addEventListener('click', () => this._step(plan, -1));
            if (inc) inc.addEventListener('click', () => this._step(plan, 1));
            input.addEventListener('change', () => this._clamp(plan));
            input.addEventListener('blur', () => this._clamp(plan));
          }
        });
        this._onBill = (e) => { if (e.detail && e.detail.source !== this && e.detail.cycle) this._apply(e.detail.cycle); };
        document.addEventListener('fleeta:billing', this._onBill);
        this.setAttribute('data-billing', this.cycle);
        this._recalcAll();
        this._syncToggleUI();
      }
      disconnectedCallback() { document.removeEventListener('fleeta:billing', this._onBill); window.clearTimeout(this._switchT); }
      _setBilling(cycle) {
        if (cycle === this.cycle) return;
        this._apply(cycle);
        document.dispatchEvent(new CustomEvent('fleeta:billing', { detail: { cycle: cycle, source: this } }));
      }
      // 페이드아웃 → 150ms 후 내용 교체 → 페이드인 (React PricingPage: opacity 200ms + 150ms 지연 교체)
      _apply(cycle) {
        this.cycle = cycle;
        var grid = this.querySelector('.fleeta-pplans__grid');
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var self = this;
        var swap = function () { self.setAttribute('data-billing', cycle); self._syncToggleUI(); self._recalcAll(); };
        if (!grid || reduce) { swap(); return; }
        grid.classList.add('is-switching');
        window.clearTimeout(this._switchT);
        this._switchT = window.setTimeout(function () { swap(); grid.classList.remove('is-switching'); }, 150);
      }
      _syncToggleUI() { this.toggles.forEach((b) => b.classList.toggle('is-active', b.getAttribute('data-billing-toggle') === this.cycle)); }
      _step(plan, dir) {
        var input = plan.querySelector('[data-count-input]');
        var max = parseInt(plan.getAttribute('data-max'), 10) || 1;
        var v = Math.max(1, Math.min(max, (parseInt(input.value, 10) || 1) + dir));
        input.value = v; this._recalc(plan);
      }
      _clamp(plan) {
        var input = plan.querySelector('[data-count-input]');
        var max = parseInt(plan.getAttribute('data-max'), 10) || 1;
        input.value = Math.max(1, Math.min(max, parseInt(input.value, 10) || 1));
        this._recalc(plan);
      }
      _n(plan, a) { return parseFloat(plan.getAttribute(a)) || 0; }
      _recalc(plan) {
        var isFree = plan.getAttribute('data-plan') === 'free';
        var input = plan.querySelector('[data-count-input]');
        var count = input ? (parseInt(input.value, 10) || 1) : 1;
        var isPromo = this.promo && plan.getAttribute('data-promo') === 'true';
        var priceEl = plan.querySelectorAll('.js-price');
        var origEl = plan.querySelectorAll('.js-price-orig');
        var totalEl = plan.querySelectorAll('.js-total');
        var billedEl = plan.querySelectorAll('.js-billed');
        var discEl = plan.querySelector('.js-discount');
        var incEl = plan.querySelector('[data-count-inc]');
        var max = parseInt(plan.getAttribute('data-max'), 10) || 1;
        if (incEl) incEl.disabled = count >= max;
        var unit, total, label, orig = null, billed = null;
        if (this.cycle === 'annual') {
          unit = isPromo ? this._n(plan, 'data-promo-annual') : this._n(plan, 'data-price-annual');
          var atp = isPromo ? this._n(plan, 'data-promo-annual-total') : this._n(plan, 'data-annual-total');
          total = atp * count; label = '$' + round(total) + '/year';
          if (isPromo) orig = this._n(plan, 'data-price-annual');
          // React PricingPage: showAnnual = annual && annualTotalPerCamera > 0 → 대당 연 총액(카운트 미반영) 노출
          if (atp > 0) billed = 'billed annually ($' + round(atp) + '/year)';
        } else {
          unit = isPromo ? this._n(plan, 'data-promo-monthly') : this._n(plan, 'data-price-monthly');
          total = unit * count; label = '$' + round(total) + '/month';
          if (isPromo) orig = this._n(plan, 'data-price-monthly');
        }
        if (isFree) { unit = 0; total = 0; label = '$0/month'; orig = null; billed = null; }
        Array.prototype.forEach.call(priceEl, (el) => { el.textContent = '$' + unit; });
        Array.prototype.forEach.call(origEl, (el) => { if (orig != null) { el.textContent = '$' + orig; el.hidden = false; } else { el.hidden = true; } });
        Array.prototype.forEach.call(totalEl, (el) => { el.textContent = 'Total ' + label; });
        Array.prototype.forEach.call(billedEl, (el) => { if (billed != null) { el.textContent = billed; el.hidden = false; } else { el.textContent = ''; el.hidden = true; } });
        // 프로모 배지: 연간뷰=연 배지(17% Off), 월간뷰=월 배지(20% Off) — React PricingPage discountBadge = showAnnual ? badgeAnnual : badgeMonthly
        if (discEl) {
          var bM = discEl.getAttribute('data-badge-monthly') || '';
          var bA = discEl.getAttribute('data-badge-annual') || '';
          discEl.textContent = this.cycle === 'annual' ? (bA || bM) : bM;
        }
      }
      _recalcAll() { this.querySelectorAll('[data-plan]').forEach((p) => this._recalc(p)); }
    }
    customElements.define('fleeta-pricing', FleetaPricing);
  })();
  
  /* <fleeta-pricing-table> — 비교표: fleeta:billing 수신해 열(starter/standard) 동기화 + 기능 툴팁 모달(단일/2스텝, Lottie=정적 대체) */
  (function () {
    if (customElements.get('fleeta-pricing-table')) return;
    function loadScriptOnce(url) {
      window.__fleetaScripts = window.__fleetaScripts || {};
      if (window.__fleetaScripts[url]) return window.__fleetaScripts[url];
      window.__fleetaScripts[url] = new Promise(function (resolve, reject) {
        var s = document.createElement('script'); s.src = url; s.async = true;
        s.onload = function () { resolve(); }; s.onerror = function () { reject(); };
        document.head.appendChild(s);
      });
      return window.__fleetaScripts[url];
    }
    class FleetaPricingTable extends HTMLElement {
      connectedCallback() {
        // 카드 그리드와 동기 페이드: 페이드아웃 → 150ms 후 열(starter/standard) 교체 → 페이드인
        this._onBill = (e) => {
          if (!e.detail || !e.detail.cycle) return;
          var cycle = e.detail.cycle;
          var box = this.querySelector('.fleeta-ptable__container');
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!box || reduce) { this.setAttribute('data-billing', cycle); return; }
          box.classList.add('is-switching');
          window.clearTimeout(this._tblSwitchT);
          this._tblSwitchT = window.setTimeout(() => { this.setAttribute('data-billing', cycle); box.classList.remove('is-switching'); }, 150);
        };
        document.addEventListener('fleeta:billing', this._onBill);
  
        this.modal = this.querySelector('[data-tooltip-modal]');
        if (this.modal) {
          this.box = this.modal.querySelector('.fleeta-ptable__modal-box');
          this.elTitle = this.modal.querySelector('[data-tt-title]');
          this.elSubtitle = this.modal.querySelector('[data-tt-subtitle]');
          this.elText = this.modal.querySelector('[data-tt-text]');
          this.elMedia = this.modal.querySelector('[data-tt-media]');
          this.elImg = this.modal.querySelector('[data-tt-image]');
          this.elLottie = this.modal.querySelector('[data-tt-lottie]');
          this.elCaption = this.modal.querySelector('[data-tt-caption]');
          this.elNav = this.modal.querySelector('[data-tt-nav]');
          this.elPrev = this.modal.querySelector('[data-tt-prev]');
          this.elNext = this.modal.querySelector('[data-tt-next]');
          this.elCounter = this.modal.querySelector('[data-tt-counter]');
          this.overlay = this.modal.querySelector('[data-tooltip-backdrop]');
          this._onKey = (e) => { if (e.key === 'Escape') this._close(); };
          this.modal.querySelectorAll('[data-tooltip-close]').forEach((b) => b.addEventListener('click', () => this._close()));
          if (this.overlay) this.overlay.addEventListener('click', () => this._close());
          if (this.elPrev) this.elPrev.addEventListener('click', () => this._go(this.step - 1));
          if (this.elNext) this.elNext.addEventListener('click', () => { if (this.step >= this.steps.length - 1) this._close(); else this._go(this.step + 1); });
        }
  
        this.querySelectorAll('[data-tooltip-trigger]').forEach((btn) => {
          btn.addEventListener('click', () => {
            var script = btn.parentNode.querySelector('script[data-tooltip]');
            if (!script) return;
            try { this._open(JSON.parse(script.textContent)); } catch (e) {}
          });
        });
      }
      disconnectedCallback() {
        document.removeEventListener('fleeta:billing', this._onBill);
        document.removeEventListener('keydown', this._onKey);
        window.clearTimeout(this._tblSwitchT);
      }
      _open(data) {
        if (!this.modal) return;
        this.data = data;
        this.steps = data.steps || [];
        this.step = 0;
        // 이미지 영역 높이(블록 설정 px) — 툴팁별로 주입. 값이 없으면 CSS 기본(19.2rem).
        var mh = parseFloat(data.mediaHeight);
        if (this.elMedia) {
          if (mh > 0) this.elMedia.style.setProperty('--fl-tt-media-h', (mh / 10) + 'rem');
          else this.elMedia.style.removeProperty('--fl-tt-media-h');
        }
        this._render(); // 제목은 단계별(_render)에서 설정 — 블록 설정 미입력 시 기능명 폴백
        this.modal.hidden = false;
        if (this.overlay) { this.overlay.classList.remove('fleeta-modal-overlay-in'); void this.overlay.offsetWidth; this.overlay.classList.add('fleeta-modal-overlay-in'); }
        if (this.box) { this.box.classList.remove('fleeta-modal-content-in'); void this.box.offsetWidth; this.box.classList.add('fleeta-modal-content-in'); }
        document.documentElement.classList.add('fleeta-no-scroll');
        document.addEventListener('keydown', this._onKey);
        var close = this.modal.querySelector('[data-tooltip-close]');
        if (close) close.focus();
      }
      _go(n) { this.step = Math.max(0, Math.min(this.steps.length - 1, n)); this._render(); }
      _playLottie() {
        var self = this;
        var lib = this.getAttribute('data-lottie-lib');
        var dataUrl = this.getAttribute('data-lottie-data');
        if (!lib || !dataUrl || !this.elLottie) return;
        Promise.all([loadScriptOnce(dataUrl), loadScriptOnce(lib)]).then(function () {
          if (self.modal.hidden || !window.lottie || !window.__fleetaVoiceCallLottie) return;
          if (!(self.steps[self.step] || {}).lottie) return; // navigated off the lottie step
          self._destroyLottie();
          self._lottieAnim = window.lottie.loadAnimation({
            container: self.elLottie, renderer: 'svg', loop: true, autoplay: true,
            animationData: window.__fleetaVoiceCallLottie
          });
        }).catch(function () {});
      }
      _destroyLottie() {
        if (this._lottieAnim) { try { this._lottieAnim.destroy(); } catch (e) {} this._lottieAnim = null; }
        if (this.elLottie) this.elLottie.innerHTML = '';
      }
      _render() {
        var s = this.steps[this.step] || {};
        var multi = this.steps.length > 1;
        // 단계별 제목(블록 설정) → 없으면 기능명. 접미(titleSuffix)는 공통.
        var title = s.title || this.data.title || '';
        this.elTitle.textContent = title + (this.data.titleSuffix ? ' ' + this.data.titleSuffix : '');
        if (s.subtitle) { this.elSubtitle.textContent = s.subtitle; this.elSubtitle.hidden = false; } else { this.elSubtitle.hidden = true; }
        this.elText.textContent = s.text || '';
        if (s.lottie) {
          this.elImg.hidden = true; this.elImg.removeAttribute('src');
          if (this.elLottie) this.elLottie.hidden = false;
          this.elMedia.hidden = false;
          this._playLottie();
        } else if (s.image) {
          this._destroyLottie(); if (this.elLottie) this.elLottie.hidden = true;
          this.elImg.hidden = false; this.elImg.src = s.image; this.elImg.alt = title;
          this.elMedia.hidden = false;
        } else {
          this._destroyLottie(); if (this.elLottie) this.elLottie.hidden = true;
          this.elImg.hidden = true; this.elImg.removeAttribute('src');
          this.elMedia.hidden = true;
        }
        if (s.caption) { this.elCaption.textContent = s.caption; this.elCaption.hidden = false; } else { this.elCaption.hidden = true; }
        this.elNav.hidden = false;
        this.elPrev.hidden = !multi || this.step === 0;
        if (multi) { this.elCounter.textContent = (this.step + 1) + '/' + this.steps.length; this.elCounter.hidden = false; }
        else { this.elCounter.hidden = true; }
        this.elNext.textContent = (this.step >= this.steps.length - 1) ? 'OK' : 'Next';
      }
      _close() {
        if (!this.modal) return;
        this.modal.hidden = true;
        document.documentElement.classList.remove('fleeta-no-scroll');
        document.removeEventListener('keydown', this._onKey);
        if (this.elImg) this.elImg.removeAttribute('src');
        this._destroyLottie();
      }
    }
    customElements.define('fleeta-pricing-table', FleetaPricingTable);
  })();
  
  /* reCAPTCHA v2(explicit) 전역 로더 — 다중 폼 공유 */
  function fleetaLoadRecaptcha() {
    if (window.__fleetaRecaptcha) return window.__fleetaRecaptcha;
    window.__fleetaRecaptcha = new Promise(function (resolve) {
      if (window.grecaptcha && window.grecaptcha.render) { resolve(); return; }
      window.__fleetaRecaptchaOnload = function () { resolve(); };
      var s = document.createElement('script');
      s.src = 'https://www.google.com/recaptcha/api.js?onload=__fleetaRecaptchaOnload&render=explicit';
      s.async = true; s.defer = true;
      s.onerror = function () { resolve(); };
      document.head.appendChild(s);
    });
    return window.__fleetaRecaptcha;
  }
  
  /* <fleeta-form> — 클라이언트 검증(필수·이메일) + honeypot + reCAPTCHA v2 + Supabase Edge Function POST.
     설정(window.FLEETA_FORMS: supabaseUrl/anonKey/recaptchaSiteKey)이 없으면 클라이언트 성공화면 폴백.
     form[data-endpoint]="send-contact-email"|"send-demo-request". 결정 §3.4(Supabase 유지). */
  (function () {
    if (customElements.get('fleeta-form')) return;
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    class FleetaForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.hideEl = this.querySelector('[data-form-hide-on-success]');
        this.showEl = this.querySelector('[data-form-show-on-success]');
        this.endpoint = this.form.getAttribute('data-endpoint') || '';
        this.recaptchaEl = this.querySelector('[data-recaptcha]');
        this.widgetId = null;
        this._onSubmit = this._submit.bind(this);
        this.form.addEventListener('submit', this._onSubmit);
        this.form.querySelectorAll('input, textarea, select').forEach((f) =>
          f.addEventListener('input', () => this._clear(f))
        );
        this._populateUtmFields();
        // reCAPTCHA v2 위젯 렌더(사이트 키 설정 시에만)
        var cfg = window.FLEETA_FORMS;
        if (cfg && cfg.recaptchaSiteKey && this.recaptchaEl) {
          var self = this;
          fleetaLoadRecaptcha().then(function () {
            if (!window.grecaptcha || !window.grecaptcha.render) return;
            try { self.widgetId = window.grecaptcha.render(self.recaptchaEl, { sitekey: cfg.recaptchaSiteKey }); } catch (e) {}
          });
        }
      }
      disconnectedCallback() { if (this.form) this.form.removeEventListener('submit', this._onSubmit); }
      _msg(field) { return this.form.querySelector('[data-error-for="' + field.name + '"]'); }
      _err(field, msg) {
        field.classList.add('is-invalid');
        var e = this._msg(field);
        if (e) { e.textContent = msg; e.hidden = false; }
      }
      _clear(field) {
        field.classList.remove('is-invalid');
        var e = this._msg(field);
        if (e) { e.hidden = true; }
      }
      _submit(ev) {
        ev.preventDefault();
        var hp = this.form.querySelector('[data-honeypot]');
        if (hp && hp.value.trim() !== '') return; // 봇
        var ok = true, first = null;
        var self = this;
        this.form.querySelectorAll('[required]').forEach(function (f) {
          if (f.type === 'radio' || f.type === 'checkbox') return; // 그룹 검증으로 처리
          self._clear(f);
          var label = f.getAttribute('data-label') || 'This field';
          if (!f.value.trim()) { self._err(f, label + ' is required'); ok = false; first = first || f; }
          else if (f.type === 'email' && !EMAIL.test(f.value)) { self._err(f, 'Please enter a valid email address'); ok = false; first = first || f; }
        });
        // radio: 같은 name 중 1개 선택 필수
        var radioSeen = {};
        this.form.querySelectorAll('input[type="radio"][required]').forEach(function (f) {
          if (radioSeen[f.name]) return;
          radioSeen[f.name] = true;
          self._clear(f);
          if (!self.form.querySelector('input[type="radio"][name="' + f.name + '"]:checked')) {
            self._err(f, (f.getAttribute('data-label') || 'This field') + ' is required');
            ok = false; first = first || f;
          }
        });
        // checkbox: 같은 name 중 1개 이상 필수
        var checkSeen = {};
        this.form.querySelectorAll('input[type="checkbox"][required]').forEach(function (f) {
          if (checkSeen[f.name]) return;
          checkSeen[f.name] = true;
          self._clear(f);
          var any = false;
          self.form.querySelectorAll('input[type="checkbox"][name="' + f.name + '"]').forEach(function (c) {
            if (c.checked) any = true;
          });
          if (!any) {
            self._err(f, (f.getAttribute('data-label') || 'This field') + ' is required');
            ok = false; first = first || f;
          }
        });
        if (!ok) { if (first) first.focus(); return; }
        var cfg = window.FLEETA_FORMS;
        if (cfg && cfg.supabaseUrl && this.endpoint) { this._backendSubmit(cfg); }
        else { this._success(); } // 백엔드 미설정 → 클라이언트 성공화면 폴백
      }
      _payload() {
        var o = {};
        this.form.querySelectorAll('input[name], textarea[name], select[name]').forEach(function (f) {
          if (f.name === 'g-recaptcha-response') return;
          /* honeypot([data-honeypot])은 의도적으로 payload에 포함한다 — 엣지 함수들이 data.website로
             서버측 봇 검사를 수행하므로, 여기서 빼면 그 분기가 영영 실행되지 않는다(방어 1겹 상실). */
          if (f.type === 'checkbox') {
            if (!f.checked) return;
            if (!Array.isArray(o[f.name])) o[f.name] = [];
            o[f.name].push(f.value);
            return;
          }
          if (f.type === 'radio') {
            if (!f.checked) return;
            o[f.name] = f.value;
            return;
          }
          o[f.name] = f.value;
        });
        this._splitName(o);
        return o;
      }

      /* 단일 "Full name" 입력을 firstName/lastName로 분리(React DemoScheduleModal splitName 이식).
         form[data-split-name="<필드명>"]을 선언한 폼에서만 동작. quick-demo-link 엣지 함수는
         data.firstName을 필수로 요구하므로(없으면 400) 전송 전에 반드시 분리해야 한다. */
      _splitName(o) {
        var src = this.form.getAttribute('data-split-name');
        if (!src || typeof o[src] !== 'string') return;
        var full = o[src].trim();
        var i = full.indexOf(' ');
        o.firstName = i === -1 ? full : full.slice(0, i);
        o.lastName = i === -1 ? '' : full.slice(i + 1);
        delete o[src];
      }
  
      _backendSubmit(cfg) {
        var self = this;
        var token = '';
        if (cfg.recaptchaSiteKey && window.grecaptcha && this.widgetId != null) {
          token = window.grecaptcha.getResponse(this.widgetId) || '';
          if (!token) { this._showError('Please complete the reCAPTCHA verification.'); return; }
        }
        var payload = this._payload();
        /* send-contact-email/send-demo-request/send-get-pricing은 data.attribution(중첩)을 읽고,
           quick-demo-link는 평문 data.utm_source/utm_medium/utm_campaign을 읽는다.
           엣지 함수들은 모두 명시한 필드만 읽으므로 둘 다 실어 보낸다(평문 키 삭제 금지 — 삭제하면
           quick-demo-link 내부 알림 메일의 UTM이 전부 'Not provided'가 된다). */
        payload.attribution = {
          utm_source: payload.utm_source || '',
          utm_medium: payload.utm_medium || '',
          utm_campaign: payload.utm_campaign || ''
        };
        payload.recaptchaToken = token;
        payload.recaptchaV2 = true;
        this._showError('');
        this._setBusy(true);
        fetch(cfg.supabaseUrl.replace(/\/$/, '') + '/functions/v1/' + this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (cfg.anonKey || '') },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (res.ok && res.d && res.d.success !== false) {
              if (window.dataLayer) {
                if (self.endpoint === 'send-demo-request') window.dataLayer.push({ event: 'fleeta_demo_requested' });
                else if (self.endpoint === 'quick-demo-link') window.dataLayer.push({ event: 'book_schedule' });
              }
              self._success();
            } else {
              self._showError((res.d && (res.d.error || res.d.message)) || 'Something went wrong. Please try again.');
              self._setBusy(false); self._resetRecaptcha();
            }
          })
          .catch(function () { self._showError('Network error. Please try again.'); self._setBusy(false); self._resetRecaptcha(); });
      }
      _setBusy(b) {
        var btn = this.form.querySelector('[type="submit"]');
        if (!btn) return;
        btn.disabled = b;
        btn.setAttribute('aria-busy', b ? 'true' : 'false');
        var busy = btn.querySelector('.fleeta-cform__submit-busy');
        if (busy) {
          busy.hidden = !b;
          busy.setAttribute('aria-hidden', b ? 'false' : 'true');
        }
      }
      _resetRecaptcha() {
        if (this.widgetId != null && window.grecaptcha) { try { window.grecaptcha.reset(this.widgetId); } catch (e) {} }
      }
      _showError(msg) {
        if (!this.errEl) {
          this.errEl = document.createElement('p');
          this.errEl.className = 'fleeta-cform__error';
          this.errEl.setAttribute('role', 'alert');
          var btn = this.form.querySelector('[type="submit"]');
          if (btn && btn.parentNode) btn.parentNode.insertBefore(this.errEl, btn.nextSibling);
          else this.form.appendChild(this.errEl);
        }
        this.errEl.textContent = msg || '';
        this.errEl.hidden = !msg;
      }
      _success() {
        if (this.hideEl) this.hideEl.hidden = true;
        if (this.showEl) this.showEl.hidden = false;
        var y = this.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
      }
      _populateUtmFields() {
        var params = new URLSearchParams(window.location.search || '');
        var map = {
          source: params.get('utm_source') || '',
          medium: params.get('utm_medium') || '',
          campaign: params.get('utm_campaign') || ''
        };
        this.form.querySelectorAll('[data-utm]').forEach(function (f) {
          var key = f.getAttribute('data-utm');
          if (key && Object.prototype.hasOwnProperty.call(map, key)) f.value = map[key];
        });
      }
    }
    customElements.define('fleeta-form', FleetaForm);
  })();
  
  /* <fleeta-product-gallery> — 상품 미디어 갤러리:
     · 썸네일 클릭 → data-media-item hidden 토글 + aria-pressed.
     · 썸네일 폭 초과 시 좌우 캐러셀: [data-thumbs-track] 가로 스크롤 + prev/next 버튼(오버플로우 감지해 노출/비활성). */
  (function () {
    if (customElements.get('fleeta-product-gallery')) return;
    class FleetaProductGallery extends HTMLElement {
      connectedCallback() {
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-media-item]'));
        if (!this.thumbs.length || !this.items.length) return;
        this._onClick = this._select.bind(this);
        this.thumbs.forEach((t) => t.addEventListener('click', this._onClick));
        this._setupCarousel();
      }
      disconnectedCallback() {
        if (this.thumbs) this.thumbs.forEach((t) => t.removeEventListener('click', this._onClick));
        if (this.track && this._onScroll) this.track.removeEventListener('scroll', this._onScroll);
        if (this.prevBtn && this._onPrev) this.prevBtn.removeEventListener('click', this._onPrev);
        if (this.nextBtn && this._onNext) this.nextBtn.removeEventListener('click', this._onNext);
        if (this._ro) { this._ro.disconnect(); this._ro = null; }
        if (this._onScroll) window.removeEventListener('resize', this._onScroll);
      }
      _select(ev) {
        var btn = ev.currentTarget;
        var id = btn.getAttribute('data-thumb');
        this.items.forEach((it) => { it.hidden = it.getAttribute('data-media-item') !== id; });
        this.thumbs.forEach((t) => {
          var on = t === btn;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      _setupCarousel() {
        this.track = this.querySelector('[data-thumbs-track]');
        this.prevBtn = this.querySelector('[data-thumb-prev]');
        this.nextBtn = this.querySelector('[data-thumb-next]');
        if (!this.track || !this.prevBtn || !this.nextBtn) return;
        this._onScroll = this._updateNav.bind(this);
        this._onPrev = this._scrollByDir.bind(this, -1);
        this._onNext = this._scrollByDir.bind(this, 1);
        this.track.addEventListener('scroll', this._onScroll, { passive: true });
        this.prevBtn.addEventListener('click', this._onPrev);
        this.nextBtn.addEventListener('click', this._onNext);
        if (typeof ResizeObserver !== 'undefined') {
          this._ro = new ResizeObserver(this._onScroll);
          this._ro.observe(this.track);
        } else {
          window.addEventListener('resize', this._onScroll);
        }
        this._updateNav();
      }
      _scrollByDir(dir) {
        if (!this.track) return;
        this.track.scrollBy({ left: dir * Math.round(this.track.clientWidth * 0.8), behavior: 'smooth' });
      }
      _updateNav() {
        if (!this.track || !this.prevBtn || !this.nextBtn) return;
        var max = this.track.scrollWidth - this.track.clientWidth;
        var overflow = max > 1;
        this.prevBtn.hidden = !overflow;
        this.nextBtn.hidden = !overflow;
        if (!overflow) return;
        var x = this.track.scrollLeft;
        this.prevBtn.disabled = x <= 1;
        this.nextBtn.disabled = x >= max - 1;
      }
    }
    customElements.define('fleeta-product-gallery', FleetaProductGallery);
  })();
  
  /* <fleeta-product-form> — 번들 상품 폼.
     · 옵션 모드([data-option-value] 라디오 + [data-variant-map]): 옵션 조합 → variant 매칭 → 숨김 name=id 갱신
       (2옵션 이상 지원: MicroSD × LTE Version). 레거시 단일옵션(variant당 name=id 라디오)도 유지.
     · 가격/취소선/Save 스왑 · ?variant= 갱신 · [data-spec-price-variant] 동기화 · 없는 조합/품절 시 버튼 비활성
     · 수량 스테퍼(min 1) · Add to Cart / Buy It Now(add 후 /checkout) · no-JS 시 네이티브 submit 강등
     · Buy it with add-on 선택 시 /cart/add.js에 items 배열(JSON) POST → 본품+추천 동시 담기
     · 성공 시 fleeta:cart:added 발행(헤더 카트 카운트 리스너가 수신) */
  (function () {
    if (customElements.get('fleeta-product-form')) return;
    class FleetaProductForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.priceEl = this.querySelector('[data-price-current]');
        this.compareEl = this.querySelector('[data-price-compare]');
        this.saveEl = this.querySelector('[data-price-save]');
        this.qtyInput = this.querySelector('[data-qty-input]');
        this.atcBtn = this.querySelector('[data-atc]');
        this.atcLabel = this.querySelector('[data-atc-label]');
        this.buyBtn = this.querySelector('[data-buy-now]');
        this.statusEl = this.querySelector('[data-form-status]');
        this.idInput = this.querySelector('[data-variant-id]');
        this.optionInputs = Array.prototype.slice.call(this.querySelectorAll('[data-option-value]'));
        this.radios = Array.prototype.slice.call(this.querySelectorAll('[data-variant-radio]'));
        this.variantMap = this._parseMap();
        this._onChange = this._variantChange.bind(this);
        this._onSubmit = this._submit.bind(this);
        this._onQty = this._qtyClick.bind(this);
        this._onBuy = this._buyNow.bind(this);
        this.optionInputs.forEach((r) => r.addEventListener('change', this._onChange));
        this.radios.forEach((r) => r.addEventListener('change', this._onChange));
        this.form.addEventListener('submit', this._onSubmit);
        this.querySelectorAll('[data-qty-dec], [data-qty-inc]').forEach((b) => b.addEventListener('click', this._onQty));
        if (this.buyBtn) this.buyBtn.addEventListener('click', this._onBuy);
        if (this.qtyInput) this.qtyInput.addEventListener('change', () => this._clampQty());
      }
      disconnectedCallback() {
        if (!this.form) return;
        this.optionInputs.forEach((r) => r.removeEventListener('change', this._onChange));
        this.radios.forEach((r) => r.removeEventListener('change', this._onChange));
        this.form.removeEventListener('submit', this._onSubmit);
        if (this.buyBtn) this.buyBtn.removeEventListener('click', this._onBuy);
      }
      _parseMap() {
        var el = this.querySelector('[data-variant-map]');
        if (!el) return [];
        try { return JSON.parse(el.textContent); } catch (e) { return []; }
      }
      _selectedOptions() {
        var opts = [];
        this.optionInputs.forEach(function (r) {
          if (r.checked) opts[parseInt(r.getAttribute('data-option-index'), 10)] = r.getAttribute('data-option-value');
        });
        return opts;
      }
      _matchVariant(opts) {
        return this.variantMap.filter(function (v) {
          if (!v.options || v.options.length !== opts.length) return false;
          for (var i = 0; i < opts.length; i++) { if (v.options[i] !== opts[i]) return false; }
          return true;
        })[0] || null;
      }
      _checked() {
        return this.radios.filter((r) => r.checked)[0] || null;
      }
      _currentVariant() {
        if (this.optionInputs.length) {
          var v = this._matchVariant(this._selectedOptions());
          if (!v) return null;
          return { id: v.id, price: v.price, compare: v.compare, save: v.save, available: v.available };
        }
        var r = this._checked();
        if (r) return { id: r.value, price: r.getAttribute('data-price'), compare: r.getAttribute('data-compare'), save: r.getAttribute('data-save-text'), available: r.getAttribute('data-available') === 'true' };
        return null;
      }
      _variantChange() {
        var v = this._currentVariant();
        if (this.optionInputs.length && this.idInput && v) this.idInput.value = v.id;
        if (!v) {
          // 없는 옵션 조합 → 담기 불가
          if (this.atcBtn) { this.atcBtn.disabled = true; if (this.atcLabel) this.atcLabel.textContent = this.dataset.soldoutText || 'Unavailable'; }
          if (this.buyBtn) this.buyBtn.disabled = true;
          return;
        }
        if (this.priceEl && v.price) this.priceEl.textContent = v.price;
        if (this.compareEl) { this.compareEl.hidden = !v.compare; this.compareEl.textContent = v.compare || ''; }
        if (this.saveEl) { this.saveEl.hidden = !v.save; this.saveEl.textContent = v.save || ''; }
        if (this.atcBtn) {
          this.atcBtn.disabled = !v.available;
          if (this.atcLabel) this.atcLabel.textContent = v.available ? (this.dataset.atcText || 'Add to Cart') : (this.dataset.soldoutText || 'Sold out');
        }
        if (this.buyBtn) this.buyBtn.disabled = !v.available;
        // 페이지 내 다른 섹션(예: Specs Bundle Price 행)의 variant별 사전렌더 값과 동기화.
        var specSpans = document.querySelectorAll('[data-spec-price-variant]');
        if (specSpans.length) {
          specSpans.forEach(function (el) {
            el.hidden = String(el.getAttribute('data-spec-price-variant')) !== String(v.id);
          });
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      _clampQty() {
        if (!this.qtyInput) return;
        var v = parseInt(this.qtyInput.value, 10);
        this.qtyInput.value = isNaN(v) || v < 1 ? 1 : v;
      }
      _qtyClick(ev) {
        if (!this.qtyInput) return;
        var dir = ev.currentTarget.hasAttribute('data-qty-inc') ? 1 : -1;
        var v = parseInt(this.qtyInput.value, 10);
        if (isNaN(v)) v = 1;
        this.qtyInput.value = Math.max(1, v + dir);
      }
      _status(html, isError) {
        if (!this.statusEl) return;
        this.statusEl.innerHTML = html;
        this.statusEl.hidden = false;
        this.statusEl.classList.toggle('is-error', !!isError);
      }
      _mainId() {
        if (this.idInput && this.idInput.value) return this.idInput.value;
        var r = this._checked();
        if (r) return r.value;
        var hid = this.form.querySelector('[name="id"]');
        return hid ? hid.value : null;
      }
      _addOns() {
        var biw = document.querySelector('fleeta-buy-it-with');
        return biw && biw.selectedAddOns ? biw.selectedAddOns() : [];
      }
      _add() {
        var routes = window.routes || {};
        var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
        this._clampQty();
        var addOns = this._addOns();
        if (!addOns.length) {
          // 단일 담기 — FormData(숨김 id + quantity + properties[...] 포함)
          var fd = new FormData(this.form);
          return fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd,
          }).then((res) => res.json().then((data) => ({ ok: res.ok, data: data })));
        }
        // 다중 담기 — items 배열(JSON). 본품 + 선택된 추천상품.
        var qty = parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1;
        var main = { id: Number(this._mainId()), quantity: qty };
        var props = {};
        this.form.querySelectorAll('[name^="properties["]').forEach(function (el) {
          if (el.type === 'checkbox' && !el.checked) return;
          var m = el.name.match(/^properties\[(.+)\]$/);
          if (m && el.value) props[m[1]] = el.value;
        });
        if (Object.keys(props).length) main.properties = props;
        var items = [main].concat(addOns);
        return fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items }),
        }).then((res) => res.json().then((data) => ({ ok: res.ok, data: data })));
      }
      _err(r) {
        return (r.data && (r.data.description || r.data.message)) || this.dataset.errorText || 'Something went wrong.';
      }
      _submit(ev) {
        ev.preventDefault();
        var self = this;
        if (this.atcBtn) this.atcBtn.disabled = true;
        this._add()
          .then((r) => {
            if (r.ok) {
              var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
              self._status(
                (self.dataset.addedText || 'Added to cart') +
                  ' — <a href="' + cartUrl + '">' + (self.dataset.viewCartText || 'View cart') + '</a>'
              );
              document.dispatchEvent(new CustomEvent('fleeta:cart:added', { detail: r.data }));
            } else {
              self._status(self._err(r), true);
            }
          })
          .catch(() => self._status(self.dataset.errorText || 'Something went wrong.', true))
          .finally(() => {
            var cur = self._currentVariant();
            var available = !cur || cur.available;
            if (self.atcBtn) self.atcBtn.disabled = !available;
          });
      }
      _buyNow(ev) {
        ev.preventDefault();
        var self = this;
        if (this.buyBtn) this.buyBtn.disabled = true;
        this._add()
          .then((r) => {
            if (r.ok) { window.location.href = '/checkout'; return; }
            self._status(self._err(r), true);
            if (self.buyBtn) self.buyBtn.disabled = false;
          })
          .catch(() => {
            self._status(self.dataset.errorText || 'Something went wrong.', true);
            if (self.buyBtn) self.buyBtn.disabled = false;
          });
      }
    }
    customElements.define('fleeta-product-form', FleetaProductForm);
  })();

  /* <fleeta-buy-it-with> — Buy it with(Search & Discovery complementary 전용).
     추천 라우트(data-url + &intent=complementary)로 이 상품 섹션을 fetch → [data-biw-source]만 추출해 주입.
     추천 0건/앱 미구성/실패 → this.remove()로 블록(헤딩 포함) 전체 미표시. 폴백 없음.
     selectedAddOns(): 값이 선택된 variant select만 [{id, quantity:1}]로 반환(FleetaProductForm이 소비). */
  (function () {
    if (customElements.get('fleeta-buy-it-with')) return;
    class FleetaBuyItWith extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url || !this.dataset.productId) return;
        var self = this;
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver(function (entries, obs) {
            if (!entries[0].isIntersecting) return;
            obs.disconnect();
            self._load();
          }, { rootMargin: '0px 0px 400px 0px' });
          this._io.observe(this);
        } else {
          this._load();
        }
      }
      disconnectedCallback() { if (this._io) this._io.disconnect(); }
      _load() {
        var self = this;
        var url = this.dataset.url + '&product_id=' + this.dataset.productId + '&section_id=' + this.dataset.sectionId;
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var holder = document.createElement('div');
            holder.innerHTML = text;
            var src = holder.querySelector('[data-biw-source]');
            if (src && src.querySelector('[data-biw-item]')) {
              self.innerHTML = src.outerHTML;
            } else {
              self.remove();
            }
          })
          .catch(function () { self.remove(); });
      }
      selectedAddOns() {
        return Array.prototype.slice.call(this.querySelectorAll('[data-biw-variant]'))
          .map(function (s) { return s.value; })
          .filter(Boolean)
          .map(function (id) { return { id: Number(id), quantity: 1 }; });
      }
    }
    customElements.define('fleeta-buy-it-with', FleetaBuyItWith);
  })();

  /* fleeta:cart:added 수신 → /cart.js 1회 조회로 헤더 [data-cart-count] 갱신.
     번들 폼은 드로어/노티피케이션을 안 쓰므로 카운트 + 인라인 "Added" 메시지가 담김 피드백. */
  (function () {
    document.addEventListener('fleeta:cart:added', function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
          });
        })
        .catch(function () {});
    });
  })();
  
  /* <fleeta-resources> — WP REST 헤드리스 블로그(§3.3): ?post=<slug> 상세 / 없으면 리스트(카테고리·검색·Load More). */
  (function () {
    if (customElements.get('fleeta-resources')) return;
    var FLEETA_CATS = [
      ['News', '2042,1559'], ['Products', '1583,1582,1930'], ['Events', '1562,2209,1880,1613,1733,1937'],
      ['Media', '1560,1693'], ['Video', '2239,1569,1606,1581,2238,1570,1571,1572,1588'], ['Reviews', '1577,1597'], ['Updates', '1602']
    ];
    var CAUGHT = '1570,1571,1572,1588';
    var EXCLUDE = '2206,2233,2234';
    var WP2 = {}; FLEETA_CATS.forEach(function (c) { c[1].split(',').forEach(function (id) { WP2[id] = c[0]; }); });
    var SHARE_SEL = '.sharedaddy,.sd-sharing-enabled,.a2a_kit,.addtoany_content,.shareaholic-canvas,[class*="social-warfare"],.swp-content-locator,.heateor_sss_sharing_container,.elementor-widget-share-buttons,.wp-block-jetpack-sharing';
    var INITIAL = 6, MORE = 12;
    var CAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M8 2v4M16 2v4M3 10h18"/></svg>';
    var ARR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
    var BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>';
    var LINK2 = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/></svg>';
    var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    // 카테고리 필터 버튼 아이콘 (lucide — React categoryIcons 이식). 기본 file-text, News=newspaper, Video=video, Caught On BlackVue=camera.
    var IC_FILETEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>';
    var IC_NEWS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8"/><path d="M15 18h-5"/><path d="M10 6h8v4h-8V6Z"/></svg>';
    var IC_VIDEO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m22 8-6 4 6 4V8Z"/><rect width="14" height="12" x="2" y="6" rx="2" ry="2"/></svg>';
    var IC_CAMERA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>';
    var CAT_ICONS = { 'News': IC_NEWS, 'Video': IC_VIDEO, 'Caught On BlackVue': IC_CAMERA };
    function catIcon(name) { return CAT_ICONS[name] || IC_FILETEXT; }
  
    function fmtDate(s) { try { return new Date(s).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }); } catch (e) { return ''; } }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function stripTags(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').trim(); }
  
    /* ── AI 요약: React blogSummary.ts / BlogDetailAiSummary.tsx 이식 ── */
    var SPARKLE = '<svg class="fleeta-res__summary-spark" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l1.7 6.3L20 10l-6.3 1.7L12 18l-1.7-6.3L4 10l6.3-1.7z"/><path d="M18.6 2.8l.6 2.2 2.2.6-2.2.6-.6 2.2-.6-2.2-2.2-.6 2.2-.6z"/></svg>';
    function reducedMotion() { try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
    function escAttr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/'/g, '&#39;'); }
    // base=window.location.origin → 상대경로('/pages/resources?post=…')도 현재 스토어 도메인 기준으로 해석해 허용. 절대 http(s) URL은 그대로 통과. 빈값은 거부(base만 있으면 origin으로 해석되므로 명시 차단).
    function isSafeHttpUrl(s) { var t = String(s == null ? '' : s).trim(); if (!t) return false; try { var u = new URL(t, window.location.origin); return u.protocol === 'http:' || u.protocol === 'https:'; } catch (e) { return false; } }
    function isSupabaseFnUrl(url) { try { var u = new URL(url, window.location.origin); return /supabase\.co$/i.test(u.hostname) && u.pathname.indexOf('/functions/v1/') >= 0; } catch (e) { return false; } }
    function pickString(o, keys) { for (var i = 0; i < keys.length; i++) { var v = o[keys[i]]; if (typeof v === 'string' && v.trim()) return v.trim(); } return undefined; }
    function appendReadMoreLink(body, link) {
      var href = link && link.trim();
      if (!href || !isSafeHttpUrl(href)) return body;
      var anchor = ' <a href="' + escAttr(href) + '" class="fleeta-res__summary-link">Read more</a>';
      if (!body || !body.trim()) return anchor.trim();
      if (body.indexOf('<') >= 0) return body + anchor;
      return esc(body) + anchor;
    }
    function rowToItem(row) {
      if (row == null) return null;
      if (typeof row === 'string') return { content: row };
      if (typeof row !== 'object' || Array.isArray(row)) return null;
      var link = pickString(row, ['link', 'Link', 'url', 'Url', 'URL', 'href', 'Href']);
      var title = pickString(row, ['title', 'Title', 'TITLE', 'heading', 'Heading', 'headline', 'Headline', 'name', 'Name']);
      var content = pickString(row, ['content', 'Content', 'summary', 'Summary', 'body', 'Body', 'text', 'Text', 'description', 'Description']);
      if (!title && !content && !link) return null;
      return { title: title, content: appendReadMoreLink(content, link), link: link };
    }
    function itemsFrom(arr) { return arr.map(rowToItem).filter(function (x) { return x && (x.title || x.content); }); }
    function normalizeSummary(raw) {
      if (raw == null) return { items: [] };
      if (typeof raw === 'object' && !Array.isArray(raw)) {
        if (raw.json !== undefined) return normalizeSummary(raw.json);
        if (raw.data !== undefined) return normalizeSummary(raw.data);
        if (raw.result !== undefined) return normalizeSummary(raw.result);
        if (typeof raw.body === 'string') { try { return normalizeSummary(JSON.parse(raw.body)); } catch (e) { /* ignore */ } }
      }
      if (Array.isArray(raw)) {
        var rows = (raw.length > 0 && typeof raw[0] === 'object' && raw[0] !== null && ('json' in raw[0])) ? raw.map(function (r) { return r.json; }) : raw;
        return { items: itemsFrom(rows) };
      }
      if (typeof raw === 'object' && !Array.isArray(raw)) {
        var headline = pickString(raw, ['headline', 'Headline']);
        var title = pickString(raw, ['title', 'Title', 'heading', 'Heading']);
        if (Array.isArray(raw.content_items)) return { headline: headline, title: title, items: itemsFrom(raw.content_items) };
        if (Array.isArray(raw.items)) return { headline: headline, title: title, items: itemsFrom(raw.items) };
        var content = pickString(raw, ['content', 'Content', 'summary', 'Summary', 'body', 'Body', 'text', 'Text']);
        if (title || headline || content) return { headline: headline, title: title, items: content ? [{ title: title, content: content }] : [] };
      }
      return { items: [] };
    }
    function assertNotN8nError(raw) {
      if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) return;
      if (typeof raw.code === 'number' && typeof raw.message === 'string') { throw new Error(raw.message + (typeof raw.hint === 'string' ? (' ' + raw.hint) : '')); }
      if (raw.success === false) { throw new Error(pickString(raw, ['message', 'Message']) || 'Weekly summary request failed.'); }
    }
    function summaryFetchInit(url, method) {
      var m = (method === 'POST') ? 'POST' : (method === 'GET' ? 'GET' : (/n8n|\/webhook/i.test(url) ? 'POST' : 'GET'));
      var headers = { 'Accept': 'application/json' };
      if (isSupabaseFnUrl(url)) { var key = window.FLEETA_FORMS && window.FLEETA_FORMS.anonKey; if (key) { headers['Authorization'] = 'Bearer ' + key; headers['apikey'] = key; } }
      if (m === 'POST') headers['Content-Type'] = 'application/json';
      var init = { method: m, mode: 'cors', cache: 'no-store', headers: headers };
      if (m === 'POST') init.body = '{}';
      return init;
    }
    function buildSummaryUrl(base, slug) {
      var t = base.trim();
      var u = /^https?:\/\//i.test(t) ? new URL(t) : new URL(t.charAt(0) === '/' ? t : ('/' + t), window.location.origin);
      u.searchParams.set('slug', slug);
      u.searchParams.set('t', String(Date.now()));
      return u.toString();
    }
    function fetchSummaryJson(url) {
      return fetch(url).then(function (res) {
        return res.text().then(function (text) {
          var data = {};
          if (text) { try { data = JSON.parse(text); } catch (e) { throw new Error(res.ok ? 'Summary API returned non-JSON.' : ('Summary API ' + res.status + ': non-JSON')); } }
          if (!res.ok) throw new Error('Summary API ' + res.status + ' ' + res.statusText);
          return data;
        });
      });
    }
    /* 여러 줄 평문을 문자 단위 병렬 타이핑 (BlogDetailAiSummary.tsx:153-205). alive()=false면 중단. */
    function typeLines(container, text, speed, alive, onDone) {
      var lines = String(text == null ? '' : text).split('\n').filter(function (l) { return l.length > 0; });
      container.innerHTML = '';
      var els = lines.map(function () { var d = document.createElement('div'); d.className = 'fleeta-res__ai-line'; container.appendChild(d); return d; });
      if (lines.length === 0) { if (onDone) onDone(); return; }
      if (reducedMotion()) { els.forEach(function (el, i) { el.textContent = lines[i]; }); if (onDone) onDone(); return; }
      var maxLen = lines.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
      var bufs = lines.map(function () { return ''; });
      var i = 0;
      (function tick() {
        if (alive && !alive()) return;
        for (var k = 0; k < lines.length; k++) { if (i < lines[k].length) bufs[k] += lines[k].charAt(i); }
        for (var j = 0; j < els.length; j++) { els[j].textContent = bufs[j]; }
        i++;
        if (i >= maxLen) { if (onDone) onDone(); return; }
        setTimeout(tick, speed);
      })();
    }
    /* HTML 항목: 평문으로 타이핑 후 완료 시 원본 HTML로 교체 (TypewriterHtml, BlogPost.tsx:141-182). */
    function typeHtml(el, html, speed, alive, onDone) {
      var plain = stripTags(html);
      if (reducedMotion() || plain.length === 0) { el.innerHTML = html; if (onDone) onDone(); return; }
      var i = 0; el.textContent = '';
      (function tick() {
        if (alive && !alive()) return;
        i++;
        if (i >= plain.length) { el.innerHTML = html; if (onDone) onDone(); return; }
        el.textContent = plain.slice(0, i);
        setTimeout(tick, speed);
      })();
    }
    /* 단일 평문(headline)을 문자 단위 타이핑 (TypewriterText, BlogPost.tsx:56-138). */
    function typeText(el, text, speed, alive, onDone) {
      var s = String(text == null ? '' : text);
      if (reducedMotion() || s.length === 0) { el.textContent = s; if (onDone) onDone(); return; }
      var i = 0; el.textContent = '';
      (function tick() {
        if (alive && !alive()) return;
        i++;
        el.textContent = s.slice(0, i);
        if (i >= s.length) { if (onDone) onDone(); return; }
        setTimeout(tick, speed);
      })();
    }
  
    class FleetaResources extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.wp = this.getAttribute('data-wp') || 'https://media.blackvue.com/wp-json/wp/v2';
        this.listEl = this.querySelector('[data-res-list]');
        this.detailEl = this.querySelector('[data-res-detail]');
        this.gridEl = this.querySelector('[data-res-grid]');
        this.catsEl = this.querySelector('[data-res-cats]');
        this.catsMobileEl = this.querySelector('[data-res-cats-mobile]');
        this.catsToggleEl = this.querySelector('[data-res-cats-toggle]');
        this.catsCurrentEl = this.querySelector('[data-res-cats-current]');
        this.catsMenuEl = this.querySelector('[data-res-cats-menu]');
        this.moreWrap = this.querySelector('[data-res-more]');
        this.moreBtn = this.querySelector('[data-res-more-btn]');
        this.emptyEl = this.querySelector('[data-res-empty]');
        this.loadingEl = this.querySelector('[data-res-loading]');
        this.errorEl = this.querySelector('[data-res-error]');
        this.searchForm = this.querySelector('[data-res-search]');
        this.searchInput = this.querySelector('[data-res-search-input]');
        this.baseTitle = document.title;
        this.state = { posts: [], hasMore: true, search: '', category: null };
        this._listInit = false;
        this.weeklyUrl = this.getAttribute('data-weekly-summary') || '';
        this.summaryMethod = (this.getAttribute('data-summary-method') || 'GET').toUpperCase();
        this.detailUrl = this.getAttribute('data-detail-summary') || '';
        this.summaryEl = this.querySelector('[data-res-summary]');
        this._weeklyLoaded = false;
        this._summaryReq = 0;
  
        var slug = new URLSearchParams(window.location.search).get('post');
        if (slug) { this._detail(slug); } else { this._initList(); }
  
        this._onPop = function () {
          var p = new URLSearchParams(window.location.search).get('post');
          if (p) { self._detail(p); }
          else { self._showList(); if (!self._listInit) self._initList(); document.title = self.baseTitle; }
        };
        window.addEventListener('popstate', this._onPop);
      }
      disconnectedCallback() { if (this._onPop) window.removeEventListener('popstate', this._onPop); if (this._onDocClick) document.removeEventListener('click', this._onDocClick); }
  
      _api(path, q) {
        var qs = Object.keys(q).filter(function (k) { return q[k] != null && q[k] !== ''; })
          .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(q[k]); }).join('&');
        return fetch(this.wp + path + (qs ? ('?' + qs) : ''), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
      }
      _show(el, on) { if (el) el.hidden = !on; }
      _loading(on) { this._show(this.loadingEl, on); }
      _error(msg) { if (this.errorEl) { this.errorEl.querySelector('p').textContent = msg || ''; this._show(this.errorEl, !!msg); } }
      _showList() { this._summaryReq = (this._summaryReq || 0) + 1; this._show(this.listEl, true); this._show(this.detailEl, false); }
      _showDetail() { this._show(this.listEl, false); this._show(this.detailEl, true); }
      _clean(html) {
        var d = document.createElement('div');
        d.innerHTML = html || '';
        d.querySelectorAll('script,style,' + SHARE_SEL).forEach(function (el) { el.remove(); });
        return d.innerHTML;
      }
      _postCats(post) {
        var terms = (post._embedded && post._embedded['wp:term'] && post._embedded['wp:term'][0]) || [];
        var names = [];
        terms.forEach(function (t) { var n = WP2[String(t.id)]; if (n && names.indexOf(n) < 0) names.push(n); });
        if (names.length === 0) names.push('Uncategorized');
        return names;
      }
      _feat(post) {
        return post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0] && post._embedded['wp:featuredmedia'][0].source_url;
      }
      _ytId(post) {
        var m = post && post.meta && post.meta.blackvue;
        var id = m && m.youtube_video_id;
        return (typeof id === 'string' && id.trim()) ? id.trim() : '';
      }
  
      /* ── 리스트 ── */
      _initList() {
        var self = this;
        this._listInit = true;
        this._showList();
        this._renderCats();
        // 모바일 드롭다운: 토글·외부클릭 리스너는 정적 마크업이라 1회만 배선 (React 484·626행 대응)
        if (this.catsToggleEl) {
          this.catsToggleEl.addEventListener('click', function (e) { e.stopPropagation(); self._toggleCatsMenu(); });
          this._onDocClick = function (e) { if (self.catsMobileEl && !self.catsMobileEl.contains(e.target)) self._closeCatsMenu(); };
          document.addEventListener('click', this._onDocClick);
        }
        this.searchForm.addEventListener('submit', function (e) { e.preventDefault(); self.state.search = self.searchInput.value.trim(); self._resetAndLoad(); });
        this.moreBtn.addEventListener('click', function () { self._loadMore(); });
        this._resetAndLoad();
        this._loadWeekly();
      }
      _renderCats() {
        var self = this;
        var cats = ['All'].concat(FLEETA_CATS.map(function (c) { return c[0]; })).concat(['Caught On BlackVue']);
        this.catsEl.innerHTML = cats.map(function (name) {
          var active = (name === 'All' && self.state.category == null) || (self.state.category === name);
          return '<button type="button" class="fleeta-res__cat' + (active ? ' is-active' : '') + '" data-cat="' + esc(name) + '">' + catIcon(name) + '<span>' + esc(name) + '</span></button>';
        }).join('');
        this.catsEl.querySelectorAll('[data-cat]').forEach(function (b) {
          b.addEventListener('click', function () { var n = b.getAttribute('data-cat'); self.state.category = (n === 'All') ? null : n; self._renderCats(); self._resetAndLoad(); });
        });
        // 모바일 드롭다운: 현재 라벨 + 메뉴 항목 (React 491·498–552행 이식)
        if (this.catsCurrentEl) this.catsCurrentEl.textContent = this.state.category || 'All Categories';
        if (this.catsMenuEl) {
          this.catsMenuEl.innerHTML = cats.map(function (name) {
            var active = (name === 'All' && self.state.category == null) || (self.state.category === name);
            return '<button type="button" role="menuitem" class="fleeta-res__cats-item' + (active ? ' is-active' : '') + '" data-cat-m="' + esc(name) + '">' + catIcon(name) + '<span>' + esc(name) + '</span></button>';
          }).join('');
          this.catsMenuEl.querySelectorAll('[data-cat-m]').forEach(function (b) {
            b.addEventListener('click', function () { var n = b.getAttribute('data-cat-m'); self.state.category = (n === 'All') ? null : n; self._closeCatsMenu(); self._renderCats(); self._resetAndLoad(); });
          });
        }
      }
      _toggleCatsMenu() {
        if (!this.catsMobileEl) return;
        var open = this.catsMobileEl.classList.toggle('is-open');
        if (this.catsMenuEl) this.catsMenuEl.hidden = !open;
        if (this.catsToggleEl) this.catsToggleEl.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      _closeCatsMenu() {
        if (!this.catsMobileEl || !this.catsMobileEl.classList.contains('is-open')) return;
        this.catsMobileEl.classList.remove('is-open');
        if (this.catsMenuEl) this.catsMenuEl.hidden = true;
        if (this.catsToggleEl) this.catsToggleEl.setAttribute('aria-expanded', 'false');
      }
      _params(perPage, offset) {
        var cat = this.state.category;
        // Paginate by offset, not page: per_page differs between the first load and Load More,
        // and WP derives offset from per_page x (page - 1), which would skip a window of posts.
        var q = { per_page: perPage, offset: offset, _embed: 1, orderby: 'date', order: 'desc' };
        if (this.state.search) q.search = this.state.search;
        if (cat === 'Caught On BlackVue') q.categories = CAUGHT;
        else if (cat) { var m = FLEETA_CATS.filter(function (c) { return c[0] === cat; })[0]; q.categories = m ? m[1] : ''; }
        else q.categories_exclude = EXCLUDE;
        return q;
      }
      _resetAndLoad() {
        var self = this;
        this.state.posts = []; this.state.hasMore = true;
        this.gridEl.innerHTML = ''; this._show(this.emptyEl, false); this._show(this.moreWrap, false);
        this._loading(true); this._error('');
        this._api('/posts', this._params(INITIAL, 0)).then(function (posts) {
          self._loading(false);
          self.state.posts = posts; self.state.hasMore = posts.length === INITIAL;
          self._renderGrid(posts, false);
          self._show(self.emptyEl, posts.length === 0);
          self._show(self.moreWrap, self.state.hasMore && posts.length > 0);
        }).catch(function () { self._loading(false); self._error('Failed to load posts. Please try again.'); });
      }
      _moreLoading(on) {
        if (!this.moreBtn) return;
        this.moreBtn.disabled = on;
        this.moreBtn.innerHTML = on
          ? '<span class="fleeta-res__more-spinner" aria-hidden="true"></span>Loading...'
          : 'Load More Posts';
      }
      _loadMore() {
        var self = this;
        if (this.moreBtn.disabled) return;
        this._moreLoading(true);
        this._api('/posts', this._params(MORE, this.state.posts.length)).then(function (posts) {
          self._moreLoading(false);
          self.state.posts = self.state.posts.concat(posts); self.state.hasMore = posts.length === MORE;
          self._renderGrid(posts, true);
          self._show(self.moreWrap, self.state.hasMore);
        }).catch(function () { self._moreLoading(false); });
      }
      _card(post) {
        var img = this._feat(post);
        var title = this._clean((post.title && post.title.rendered) || esc(post.slug));
        var excerpt = this._clean((post.excerpt && post.excerpt.rendered) || '');
        var pills = this._postCats(post).map(function (n) { return '<span class="fleeta-res__pill">' + esc(n) + '</span>'; }).join('');
        var media = '<span class="fleeta-res__card-media" data-slug="' + esc(post.slug) + '" role="link" tabindex="0">' +
          (img ? '<img loading="lazy" src="' + esc(img) + '" alt="">' : '<span class="fleeta-res__card-noimg">No image</span>') + '</span>';
        return '<article class="fleeta-res__card">' + media +
          '<div class="fleeta-res__card-body">' +
          '<div class="fleeta-res__meta">' + CAL + '<span>' + esc(fmtDate(post.date)) + '</span></div>' +
          '<div class="fleeta-res__pills">' + pills + '</div>' +
          '<h2 class="fleeta-res__card-title">' + title + '</h2>' +
          '<div class="fleeta-res__card-excerpt">' + excerpt + '</div>' +
          '<button type="button" class="fleeta-res__read" data-slug="' + esc(post.slug) + '">Read More ' + ARR + '</button>' +
          '</div></article>';
      }
      _renderGrid(posts, append) {
        var self = this;
        if (!append) this.gridEl.innerHTML = '';
        this.gridEl.insertAdjacentHTML('beforeend', posts.map(function (p) { return self._card(p); }).join(''));
        this.gridEl.querySelectorAll('[data-slug]').forEach(function (el) {
          if (el.__wired) return; el.__wired = true;
          el.addEventListener('click', function () { self._go(el.getAttribute('data-slug')); });
          if (el.getAttribute('role') === 'link') el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self._go(el.getAttribute('data-slug')); } });
        });
      }
  
      /* ── 주간 AI 요약 (WeeklyAiSummaryCard 이식) ── */
      _loadWeekly() {
        if (this._weeklyLoaded) return;
        this._weeklyLoaded = true;
        var self = this, el = this.summaryEl;
        if (!el || !this.weeklyUrl) return;
        el.innerHTML = '<div class="fleeta-res__summary-loading"><span class="fleeta-res__spinner" aria-hidden="true"></span></div>';
        this._show(el, true);
        fetch(this.weeklyUrl, summaryFetchInit(this.weeklyUrl, this.summaryMethod)).then(function (r) {
          return r.text().then(function (t) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            if (!t.trim()) return { items: [] };
            var raw; try { raw = JSON.parse(t); } catch (e) { throw new Error('non-JSON'); }
            assertNotN8nError(raw);
            return normalizeSummary(raw);
          });
        }).then(function (payload) {
          if (self.isConnected) self._renderWeekly(payload);
        }).catch(function () {
          if (!self.isConnected) return;
          el.innerHTML = '<div class="fleeta-res__summary-error">Unable to load content overview (check URL, CORS, or use same-origin JSON).</div>';
          self._show(el, true);
        });
      }
      _renderWeekly(payload) {
        var self = this, el = this.summaryEl;
        if (!el) return;
        var items = (payload.items || []).filter(function (it) { return it && it.content && it.content.trim(); });
        var hasHeadline = !!(payload.headline && payload.headline.trim());
        if (!hasHeadline && items.length === 0) { this._show(el, false); return; }
        el.innerHTML = '<div class="fleeta-res__summary-badge">' + SPARKLE + '<span>Weekly AI Summary</span></div>' +
          '<div class="fleeta-res__summary-body">' +
          (hasHeadline ? '<div class="fleeta-res__summary-headline" data-wk-head></div>' : '') +
          items.map(function (_, idx) {
            return '<div class="fleeta-res__summary-item"><span class="fleeta-res__summary-bullet" aria-hidden="true"></span><div class="fleeta-res__summary-text" data-wk-item="' + idx + '"></div></div>';
          }).join('') +
          '</div>';
        this._show(el, true);
        var alive = function () { return self.isConnected; };
        if (hasHeadline) typeText(el.querySelector('[data-wk-head]'), payload.headline.trim(), 8, alive, null);
        items.forEach(function (it, idx) {
          var target = el.querySelector('[data-wk-item="' + idx + '"]');
          if (!target) return;
          var content = (it.title && it.title.trim() ? '<strong>[' + esc(it.title.trim()) + ']</strong> ' : '') + it.content;
          typeHtml(target, self._clean(content), 12, alive, null);
        });
      }
  
      /* ── 상세 ── */
      _go(slug) {
        var url = new URL(window.location.href); url.searchParams.set('post', slug);
        window.history.pushState({ post: slug }, '', url.toString());
        window.scrollTo({ top: 0, behavior: 'auto' });
        this._detail(slug);
      }
      _back() {
        var url = new URL(window.location.href); url.searchParams.delete('post');
        window.history.pushState({}, '', url.toString());
        document.title = this.baseTitle;
        this._showList();
        if (!this._listInit) this._initList();
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
      _detail(slug) {
        var self = this;
        this._showDetail(); this._loading(true); this._error(''); this.detailEl.innerHTML = '';
        this._api('/posts', { slug: slug, _embed: 1 }).then(function (arr) {
          self._loading(false);
          var post = Array.isArray(arr) ? arr[0] : null;
          if (!post) { self._error('Post not found.'); return; }
          self._renderDetail(post);
        }).catch(function () { self._loading(false); self._error('Failed to load post.'); });
      }
      _renderDetail(post) {
        var self = this;
        var img = this._feat(post);
        var vid = this._ytId(post);
        var title = this._clean((post.title && post.title.rendered) || esc(post.slug));
        var content = this._clean((post.content && post.content.rendered) || '');
        var pills = this._postCats(post).map(function (n) { return '<span class="fleeta-res__pill">' + esc(n) + '</span>'; }).join('');
        /* 비디오(youtube_video_id) 우선, 없으면 featured 이미지 — 레퍼런스 checkForMedia 이식 */
        var media = vid
          ? '<div class="fleeta-res__video">' +
              '<div class="fleeta-res__video-frame"><iframe src="https://www.youtube.com/embed/' + encodeURIComponent(vid) + '?autoplay=1&mute=1" title="' + escAttr(stripTags(title)) + '" loading="lazy" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" referrerpolicy="strict-origin" allowfullscreen></iframe></div>' +
              '<div class="fleeta-res__video-cap"><h3 class="fleeta-res__video-title">' + title + '</h3><p class="fleeta-res__video-desc">Watch this video content</p></div>' +
            '</div>'
          : (img ? '<div class="fleeta-res__hero"><img src="' + esc(img) + '" alt=""></div>' : '');
        this.detailEl.innerHTML =
          '<button type="button" class="fleeta-res__back" data-res-back>' + BACK + 'Back to Resources</button>' + media +
          '<div class="fleeta-res__card2">' +
          '<div class="fleeta-res__detail-meta"><span class="fleeta-res__pills" style="margin:0">' + pills + '</span><span class="fleeta-res__meta" style="margin:0">' + CAL + '<span>' + esc(fmtDate(post.date)) + '</span></span>' +
          '<button type="button" class="fleeta-res__copy" data-res-copy aria-label="Copy Link">' + LINK2 + '<span>Copy Link</span></button></div>' +
          '<h1 class="fleeta-res__detail-title">' + title + '</h1>' +
          (this.detailUrl ? '<div class="fleeta-res__ai" data-res-ai></div>' : '') +
          '<div class="fleeta-res__content">' + content + '</div></div>' +
          '<div class="fleeta-res__footer"><button type="button" class="fleeta-res__back" data-res-back>' + BACK + 'Back to Resources</button></div>';
        try { document.title = stripTags(title) + ' – FLEETA'; } catch (e) {}
        this.detailEl.querySelectorAll('[data-res-back]').forEach(function (b) { b.addEventListener('click', function () { self._back(); }); });
        var copyBtn = this.detailEl.querySelector('[data-res-copy]');
        if (copyBtn) copyBtn.addEventListener('click', function () { self._copyLink(copyBtn); });
        if (this.detailUrl) this._loadDetailSummary(post.slug);
      }
      /* ── Copy Link (BlogReadMore ShareButton 이식): 현재 상세 URL 클립보드 복사 ── */
      _copyLink(btn) {
        var self = this, url = window.location.href;
        var ok = function () { self._copyState(btn, 'copied'); };
        var no = function () { self._copyState(btn, 'error'); };
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(ok, no); return; }
        } catch (e) { /* fall through */ }
        try {
          var t = document.createElement('textarea');
          t.value = url; t.setAttribute('readonly', ''); t.style.position = 'absolute'; t.style.left = '-9999px';
          document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t); ok();
        } catch (e) { no(); }
      }
      _copyState(btn, state) {
        btn.classList.remove('is-copied', 'is-error');
        btn.classList.add(state === 'copied' ? 'is-copied' : 'is-error');
        btn.innerHTML = state === 'copied' ? (CHECK + '<span>Link copied!</span>') : ('<span>Failed to copy</span>');
        clearTimeout(this._copyT);
        this._copyT = setTimeout(function () {
          btn.classList.remove('is-copied', 'is-error');
          btn.innerHTML = LINK2 + '<span>Copy Link</span>';
        }, 2000);
      }
      /* ── 글 상세 AI 요약 (BlogDetailAiSummary 이식) ── */
      _loadDetailSummary(slug) {
        var self = this;
        var box = this.detailEl.querySelector('[data-res-ai]');
        if (!box || !this.detailUrl) return;
        var token = this._summaryReq = (this._summaryReq || 0) + 1;
        var alive = function () { return self._summaryReq === token && self.isConnected; };
        var HEAD = '<span class="fleeta-res__ai-header">AI Summary</span>';
        var MESSAGES = ['The AI is comprehending the sentence...', 'The AI is understanding the context...', 'The AI is understanding the context...'];
        box.innerHTML = HEAD + '<div class="fleeta-res__ai-loading">Generating summary...</div>';
        var loadingEl = box.querySelector('.fleeta-res__ai-loading');
        var attempt = 0;
        function fail(kind) {
          if (!alive()) return;
          var msg = kind === 'not_ready'
            ? "The AI summary isn't quite ready. Please refresh the page to check again."
            : 'Failed to load summary.';
          box.innerHTML = HEAD + '<p class="fleeta-res__ai-loading" style="margin:0">' + esc(msg) + '</p>';
        }
        function done(summary) {
          if (!alive()) return;
          box.innerHTML = HEAD + '<div class="fleeta-res__ai-result" data-ai-result></div>';
          var res = box.querySelector('[data-ai-result]');
          setTimeout(function () { if (alive() && res) res.classList.add('is-in'); }, 100);
          typeLines(res, summary, 8, alive, null);
        }
        function step() {
          if (!alive()) return;
          fetchSummaryJson(buildSummaryUrl(self.detailUrl, slug)).then(function (data) {
            if (!alive()) return;
            if (data && data.status === 'done' && data.data && data.data.summary) { done(data.data.summary); return; }
            if (attempt < 3) { if (loadingEl) loadingEl.textContent = MESSAGES[attempt] || MESSAGES[0]; attempt++; setTimeout(step, 5000); }
            else if (attempt === 3) { if (loadingEl) loadingEl.textContent = 'Almost complete. Checking the results....'; attempt++; setTimeout(step, 4000); }
            else { fail('not_ready'); }
          }).catch(function () { fail('error'); });
        }
        step();
      }
    }
    customElements.define('fleeta-resources', FleetaResources);
  })();
  
  /* .fleeta-pg__more — 카테고리 카드 "Learn More" 인페이지 앵커를 부드럽게 스크롤.
     React Dashcams(scrollIntoView block:'center' + history.replaceState) 이식. structure-map §F */
  (function () {
    if (window.__fleetaPgSmoothScroll) return;
    window.__fleetaPgSmoothScroll = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a.fleeta-pg__more[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
    });
  })();

  /* ── Platform(Developers) 공용 헬퍼 — fleeta-dev-* 섹션 ───────────────────────────── */

  /* [data-fl-reveal] / [data-fl-inview] — React <Reveal> + useInView 이식(one-shot, rootMargin 0 0 -10% 0).
     [data-fl-reveal="up|left|right|none"]: 뷰 진입 시 .is-in → CSS(fleeta-system.css §11)가 페이드/슬라이드.
       스태거는 요소 인라인 style="transition-delay:80ms"(원본 delay prop).
     [data-fl-inview]: 뷰 진입 1회 .is-inview + 'fl:inview' 이벤트(다이어그램 comet·오토플레이 트리거).
       data-fl-inview-threshold="0.3"(기본 0.15). 소비 측은 연결 시 .is-inview를 먼저 확인하고 이벤트도 구독할 것
       (reduced-motion·IO 미지원·테마 에디터에선 스캔 즉시 표시되므로 이벤트가 먼저 발생할 수 있음). */
  (function () {
    if (window.__fleetaFlReveal) return;
    window.__fleetaFlReveal = true;
    var immediate = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
      !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode);
    var observers = {};
    function mark(el) {
      if (el.hasAttribute('data-fl-reveal')) el.classList.add('is-in');
      if (el.hasAttribute('data-fl-inview') && !el.classList.contains('is-inview')) {
        el.classList.add('is-inview');
        el.dispatchEvent(new CustomEvent('fl:inview'));
      }
    }
    function observerFor(threshold) {
      var key = String(threshold);
      if (!observers[key]) {
        observers[key] = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            obs.unobserve(en.target);
            mark(en.target);
          });
        }, { threshold: threshold, rootMargin: '0px 0px -10% 0px' });
      }
      return observers[key];
    }
    function scan(root) {
      var els = (root || document).querySelectorAll('[data-fl-reveal]:not(.is-in), [data-fl-inview]:not(.is-inview)');
      Array.prototype.forEach.call(els, function (el) {
        if (immediate) { mark(el); return; }
        var t = parseFloat(el.getAttribute('data-fl-inview-threshold'));
        observerFor(isNaN(t) ? 0.15 : t).observe(el);
      });
    }
    scan(document);
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  /* [data-cta-label] 클릭 → dataLayer 'fleeta_cta_click' (React lib/analytics trackCtaClick와 동일 payload).
     data-cta-location="hero|reader-paths|cta-section…", 추가 필드는 data-cta-extra='{"page":"developers"}'(JSON).
     dataLayer 없으면(GTM 미로드 dev·프리뷰) 무동작 — 원본 pushEvent 동일. */
  (function () {
    if (window.__fleetaCtaTrack) return;
    window.__fleetaCtaTrack = true;
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('[data-cta-label]');
      if (!el || !window.dataLayer) return;
      var payload = {
        event: 'fleeta_cta_click',
        cta_label: el.getAttribute('data-cta-label'),
        cta_location: el.getAttribute('data-cta-location') || ''
      };
      var extra = el.getAttribute('data-cta-extra');
      if (extra) {
        try {
          var o = JSON.parse(extra);
          Object.keys(o).forEach(function (k) { payload[k] = o[k]; });
        } catch (err) { /* 잘못된 JSON은 추가 필드만 생략 */ }
      }
      window.dataLayer.push(payload);
    }, true);
  })();

  /* [data-fl-copy] 버튼 → 클립보드 복사 (React CopyButton·CodePeek·AgentReceiptCard 이식, "Copied" 1.5초).
     원천: data-fl-copy-text 속성 → 없으면 data-fl-copy-target 선택자(가장 가까운 [data-fl-copy-scope] 안 → 없으면 document).
       <template>이면 content의 텍스트. 표시: [data-fl-copy-label](없으면 버튼 자신) 텍스트를 data-fl-copied-text(기본 Copied)로.
     실패는 조용히 무시(원본 동일). */
  (function () {
    if (window.__fleetaFlCopy) return;
    window.__fleetaFlCopy = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-fl-copy]');
      if (!btn || !navigator.clipboard) return;
      var text = btn.getAttribute('data-fl-copy-text');
      if (text === null) {
        var sel = btn.getAttribute('data-fl-copy-target');
        var scope = btn.closest('[data-fl-copy-scope]') || document;
        var src = sel ? scope.querySelector(sel) : null;
        if (!src) return;
        text = src.content ? src.content.textContent : src.textContent;
      }
      var label = btn.querySelector('[data-fl-copy-label]') || btn;
      navigator.clipboard.writeText(text).then(function () {
        if (!btn.__flCopyOrig) btn.__flCopyOrig = label.textContent;
        label.textContent = btn.getAttribute('data-fl-copied-text') || 'Copied';
        window.clearTimeout(btn.__flCopyTimer);
        btn.__flCopyTimer = window.setTimeout(function () {
          label.textContent = btn.__flCopyOrig;
          btn.__flCopyOrig = null;
        }, 1500);
      }).catch(function () {});
    });
  })();

  /* <fleeta-approval-gate> — Developers 승인 게이트 워크스루 (React ApprovalGate 이식).
     가장 가까운 [data-fl-inview](섹션, threshold 0.2) 진입 시 0→1→2단계를 1100ms 간격으로 진행.
     단계 버튼([data-gate-goto])·Approve([data-gate-approve])·Cancel([data-gate-cancel]) 조작 시 자동 진행 중단.
     reduced-motion이면 즉시 마지막 단계. 상태 표시: [data-gate-state=pending|approved|cancelled], [data-gate-receipt=done|cancelled]. */
  (function () {
    if (customElements.get('fleeta-approval-gate')) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    class FleetaApprovalGate extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-gate-step]'));
        if (!this.steps.length) return;
        this.last = this.steps.length - 1;
        this.active = 0;
        this.cancelled = false;
        this.interacted = false;
        this.timers = [];
        this.querySelectorAll('[data-gate-goto]').forEach(function (btn) {
          btn.addEventListener('click', function () { self._goTo(parseInt(btn.getAttribute('data-gate-goto'), 10) || 0); });
        });
        this.querySelectorAll('[data-gate-approve]').forEach(function (btn) {
          btn.addEventListener('click', function () { self._goTo(self.last); });
        });
        this.querySelectorAll('[data-gate-cancel]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            self._stop();
            self.interacted = true;
            self.cancelled = true;
            self.active = Math.min(1, self.last);
            self._render();
          });
        });
        var host = this.closest('[data-fl-inview]') || this;
        var start = function () { self._start(); };
        if (host.classList.contains('is-inview')) start();
        else host.addEventListener('fl:inview', start, { once: true });
        this._render();
      }
      disconnectedCallback() { this._stop(); }
      _start() {
        if (this.interacted) return;
        if (reduce) { this.active = this.last; this._render(); return; }
        var self = this;
        this.steps.forEach(function (_, i) {
          self.timers.push(window.setTimeout(function () {
            if (self.interacted) return;
            self.active = i;
            self._render();
          }, i * 1100));
        });
      }
      _stop() {
        this.timers.forEach(function (id) { window.clearTimeout(id); });
        this.timers = [];
      }
      _goTo(i) {
        this._stop();
        this.interacted = true;
        this.cancelled = false;
        this.active = i;
        this._render();
      }
      _render() {
        var active = this.active;
        this.steps.forEach(function (el, i) {
          el.classList.toggle('is-current', i === active);
          el.classList.toggle('is-done', i <= active);
          var btn = el.querySelector('[data-gate-goto]');
          if (btn) {
            if (i === active) btn.setAttribute('aria-current', 'step');
            else btn.removeAttribute('aria-current');
          }
        });
        var state = this.cancelled ? 'cancelled' : active >= this.last ? 'approved' : 'pending';
        this.querySelectorAll('[data-gate-state]').forEach(function (el) {
          el.hidden = el.getAttribute('data-gate-state') !== state;
        });
        var cancelled = this.cancelled;
        this.querySelectorAll('[data-gate-receipt]').forEach(function (el) {
          el.hidden = (el.getAttribute('data-gate-receipt') === 'cancelled') !== cancelled;
        });
      }
    }
    customElements.define('fleeta-approval-gate', FleetaApprovalGate);
  })();

  /* <fleeta-dev-presets> — Developers 플랜 도달 섹션의 플릿 크기 프리셋 (React PlanReach 이식).
     [data-preset-btn="i"] 클릭 → aria-pressed·.is-selected 갱신, [data-preset-panel="i"]만 표시(나머지 hidden).
     서버 렌더가 초기 선택 상태를 이미 갖고 있으므로 연결 시에는 아무것도 바꾸지 않는다. */
  (function () {
    if (customElements.get('fleeta-dev-presets')) return;
    class FleetaDevPresets extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-preset-btn]'));
        this.buttons.forEach(function (btn) {
          btn.addEventListener('click', function () { self._select(btn.getAttribute('data-preset-btn')); });
        });
      }
      _select(key) {
        this.buttons.forEach(function (btn) {
          var on = btn.getAttribute('data-preset-btn') === key;
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.classList.toggle('is-selected', on);
        });
        this.querySelectorAll('[data-preset-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-preset-panel') !== key;
        });
      }
    }
    customElements.define('fleeta-dev-presets', FleetaDevPresets);
  })();

  /* <fleeta-agent-receipt> — Developers 히어로의 에이전트 영수증 카드 (React AgentReceiptCard 이식).
     서버 렌더는 시나리오 0의 완료 상태. JS가 붙으면(모션 허용 시) 원본처럼 비운 뒤, 뷰 진입([data-fl-inview] 0.25)부터
     24ms 틱 타임라인으로 질문 타이핑 → trace → 답변 타이핑 → 표 → 클립 순서로 드러낸다(프레임은 경과시간에서 계산).
     칩: 시나리오 전환 후 재생 / 뒤집기: aria-hidden·tabindex·포커스 이동 / 복사: [data-fl-copy-text] 갱신(공용 복사 헬퍼).
     reduced-motion: 완료 상태 유지, 전환·SMIL 애니메이션 없음. 데이터: 카드 안 JSON(시나리오·툴 스코프). */
  (function () {
    if (customElements.get('fleeta-agent-receipt')) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var MARKERS = ['①', '②', '③', '④'];
    var TICK_MS = 24;
    var T = { questionEnd: 400, traceAt: 620, answerStart: 760, answerEnd: 1400, tableAt: 1520, clipAt: 1900, end: 2100 };
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }
    function slice(text, p) {
      return text.slice(0, Math.ceil(text.length * Math.min(Math.max(p, 0), 1)));
    }
    function cite(n) { return '<sup class="fleeta-arc__cite">' + MARKERS[n - 1] + '</sup>'; }
    function clipSvg(clip, animated) {
      var ex = clip.eventX;
      var grid = '<g stroke="#ffffff" stroke-opacity="0.06" stroke-width="1">' +
        [14, 32, 50].map(function (y) { return '<line x1="0" y1="' + y + '" x2="300" y2="' + y + '"/>'; }).join('') +
        [60, 120, 180, 240].map(function (x) { return '<line x1="' + x + '" y1="0" x2="' + x + '" y2="56"/>'; }).join('') + '</g>';
      var marker = animated
        ? '<circle r="3.5" fill="#fff" stroke="#a855f7" stroke-width="2"><animateMotion dur="5s" repeatCount="indefinite" path="' + clip.path + '"/></circle>'
        : '<circle cx="' + clip.parked[0] + '" cy="' + clip.parked[1] + '" r="3.5" fill="#fff" stroke="#a855f7" stroke-width="2"/>';
      var playhead = animated
        ? '<g><animateTransform attributeName="transform" type="translate" from="0 0" to="276 0" dur="5s" repeatCount="indefinite"/><line x1="12" y1="56" x2="12" y2="98" stroke="#fff" stroke-opacity="0.75" stroke-width="1"/></g>'
        : '<line x1="' + ex + '" y1="56" x2="' + ex + '" y2="98" stroke="#fff" stroke-opacity="0.4" stroke-width="1"/>';
      return '<svg viewBox="0 0 300 100" class="fleeta-arc__svg" role="img" aria-label="Reconstructed route and speed trace for ' + esc(clip.label) + '">' +
        grid +
        '<path d="' + clip.path + '" fill="none" stroke="#a855f7" stroke-width="3" stroke-linecap="round"/>' +
        '<path d="' + clip.path + '" fill="none" stroke="#e9d5ff" stroke-opacity="0.5" stroke-width="1" stroke-dasharray="3 5"/>' +
        marker +
        '<line x1="0" y1="58" x2="300" y2="58" stroke="#ffffff" stroke-opacity="0.1"/>' +
        '<polyline points="' + clip.points + '" fill="none" stroke="#c4b5fd" stroke-width="1.5" stroke-linejoin="round"/>' +
        '<line x1="' + ex + '" y1="58" x2="' + ex + '" y2="96" stroke="#fb7185" stroke-width="1" stroke-dasharray="2 3"/>' +
        playhead + '</svg>';
    }

    class FleetaAgentReceipt extends HTMLElement {
      connectedCallback() {
        var self = this;
        try {
          this.scenarios = JSON.parse(this.querySelector('[data-arc-scenarios]').textContent);
          this.tools = JSON.parse(this.querySelector('[data-arc-tools]').textContent);
        } catch (err) { return; }
        var q = function (sel) { return self.querySelector(sel); };
        this.front = q('[data-arc-face="front"]');
        this.back = q('[data-arc-face="back"]');
        this.qEl = q('[data-arc-q]');
        this.qSizer = q('[data-arc-q-sizer]');
        this.aEl = q('[data-arc-a]');
        this.aSizer = q('[data-arc-a-sizer]');
        this.traceEl = q('[data-arc-trace]');
        this.rowsEl = q('[data-arc-rows]');
        this.noteEl = q('[data-arc-note]');
        this.cols = Array.prototype.slice.call(this.querySelectorAll('[data-arc-col]'));
        this.clipCh = q('[data-arc-clip-ch]');
        this.clipLabel = q('[data-arc-clip-label]');
        this.clipStamp = q('[data-arc-clip-stamp]');
        this.svgBox = q('[data-arc-svg]');
        this.callsEl = q('[data-arc-calls]');
        this.receiptNote = q('[data-arc-receipt-note]');
        this.copyBtn = q('[data-arc-copy]');
        this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-arc-chip]'));
        this.flipBtns = Array.prototype.slice.call(this.querySelectorAll('[data-arc-flip-btn]'));
        this.stages = Array.prototype.slice.call(this.querySelectorAll('[data-arc-stage]'));
        this.index = 0;
        this.flipped = false;
        this.inView = false;

        this.chips.forEach(function (chip) {
          chip.addEventListener('click', function () { self._select(parseInt(chip.getAttribute('data-arc-chip'), 10) || 0); });
        });
        this.flipBtns.forEach(function (btn) {
          btn.addEventListener('click', function () { self._toggleFlip(); });
        });
        if (this.copyBtn) this.copyBtn.setAttribute('data-fl-copy', '');
        this._setCopyText();
        this._applyFaces();
        this._rowDelays();

        if (reduce) return; // 서버 렌더 완료 상태 그대로(원본 reduced-motion)
        this.classList.add('is-running');
        this._frame(this.scenarios[0], 0); // 원본 초기 프레임: 빈 질문 + 캐럿, 단계 모두 숨김
        var start = function () { self.inView = true; self._renderClip(); self._run(); };
        if (this.classList.contains('is-inview')) start();
        else this.addEventListener('fl:inview', start, { once: true });
      }
      disconnectedCallback() { this._stop(); }
      _stop() { if (this.timer) { window.clearInterval(this.timer); this.timer = null; } }
      _run() {
        var self = this;
        var sc = this.scenarios[this.index];
        this._stop();
        this._frame(sc, 0);
        var startedAt = Date.now();
        this.timer = window.setInterval(function () {
          var elapsed = Math.min(Date.now() - startedAt, T.end);
          self._frame(sc, elapsed);
          if (elapsed >= T.end) self._stop();
        }, TICK_MS);
      }
      _frame(sc, t) {
        var stage = t >= T.clipAt ? 4 : t >= T.tableAt ? 3 : t >= T.answerStart ? 2 : t >= T.traceAt ? 1 : 0;
        var qText = slice(sc.question, t / T.questionEnd);
        var aText = t < T.answerStart ? '' : slice(sc.answer, (t - T.answerStart) / (T.answerEnd - T.answerStart));
        if (qText !== this._q) {
          this.qEl.textContent = qText;
          if (qText.length < sc.question.length) {
            var caret = document.createElement('span');
            caret.className = 'fleeta-arc__caret';
            this.qEl.appendChild(caret);
          }
          this._q = qText;
        }
        if (aText !== this._a) { this.aEl.textContent = aText; this._a = aText; }
        if (stage !== this._stage) {
          this.stages.forEach(function (el) {
            el.classList.toggle('is-on', parseInt(el.getAttribute('data-arc-stage'), 10) <= stage);
          });
          this._stage = stage;
        }
      }
      _select(i) {
        if (!this.scenarios[i]) return;
        this.index = i;
        this.chips.forEach(function (chip, ci) {
          var on = ci === i;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this._renderScenario();
        if (reduce || !this.inView) {
          var sc = this.scenarios[i];
          this.qEl.textContent = sc.question;
          this.aEl.textContent = sc.answer;
          this._q = sc.question;
          this._a = sc.answer;
          return;
        }
        this._q = null;
        this._a = null;
        this._stage = -1;
        this._run();
      }
      _renderScenario() {
        var self = this;
        var sc = this.scenarios[this.index];
        this.qSizer.textContent = sc.question;
        this.aSizer.textContent = sc.answer;
        this.traceEl.innerHTML = 'Scanned ' + sc.trace.map(function (seg, i) {
          return '<span>' + (i > 0 ? '<span class="fleeta-arc__sep"> · </span>' : '') + esc(seg[1]) + cite(seg[0]) + '</span>';
        }).join('');
        this.cols.forEach(function (th, i) { th.textContent = sc.columns[i]; });
        this.rowsEl.innerHTML = sc.rows.map(function (r) {
          return '<tr class="fleeta-arc__row">' +
            '<td class="fleeta-arc__td-vehicle"><span class="fleeta-arc__vehicle">' + esc(r[0]) + '</span><span class="fleeta-arc__folded">' + esc(r[1]) + '</span></td>' +
            '<td class="fleeta-arc__mid fleeta-arc__td-time">' + esc(r[1]) + '</td>' +
            '<td class="fleeta-arc__td-value">' + esc(r[2]) + cite(r[3]) + '</td></tr>';
        }).join('');
        this._rowDelays();
        this.noteEl.textContent = sc.note || '';
        this.clipCh.textContent = sc.clip.channel;
        this.clipLabel.textContent = sc.clip.label;
        this.clipStamp.textContent = sc.clip.stamp;
        this._renderClip();
        this.callsEl.innerHTML = sc.calls.map(function (c) {
          var meta = self.tools[c[1]] || { scope: '', kind: 'read' };
          return '<li class="fleeta-arc__call">' +
            '<p class="fleeta-arc__call-line"><span class="fleeta-arc__call-n">' + MARKERS[c[0] - 1] + '</span>' +
            '<span class="fleeta-arc__call-tool">' + esc(c[1]) + '<span class="fleeta-arc__call-args">' + esc(c[2]) + '</span></span></p>' +
            '<p class="fleeta-arc__call-meta"><span class="fleeta-arc__call-arrow">→</span>' +
            '<span class="fleeta-arc__call-result">' + esc(c[3]) + '</span>' +
            '<span class="fleeta-arc__call-ms">' + c[4] + ' ms</span>' +
            '<span class="fleeta-arc__scope' + (meta.kind === 'write' ? ' is-write' : '') + '">' + esc(meta.scope) + '</span></p></li>';
        }).join('');
        this.receiptNote.textContent = sc.receiptNote || '';
        this.receiptNote.hidden = !sc.receiptNote;
        this._setCopyText();
        this._applyFaces();
      }
      _renderClip() {
        var sc = this.scenarios[this.index];
        this.svgBox.innerHTML = clipSvg(sc.clip, !reduce && this.inView);
      }
      _rowDelays() {
        Array.prototype.forEach.call(this.rowsEl.querySelectorAll('.fleeta-arc__row'), function (row, i) {
          row.style.setProperty('--arc-row-delay', i * 90 + 'ms');
        });
      }
      _setCopyText() {
        if (!this.copyBtn) return;
        var sc = this.scenarios[this.index];
        this.copyBtn.setAttribute('data-fl-copy-text', sc.calls.map(function (c) {
          return MARKERS[c[0] - 1] + ' ' + c[1] + c[2] + ' -> ' + c[3];
        }).join('\n'));
      }
      _applyFaces() {
        var flipped = this.flipped;
        this.classList.toggle('is-flipped', flipped);
        [[this.front, !flipped], [this.back, flipped]].forEach(function (pair) {
          var face = pair[0];
          var active = pair[1];
          if (!face) return;
          if (active) face.removeAttribute('aria-hidden');
          else face.setAttribute('aria-hidden', 'true');
          Array.prototype.forEach.call(face.querySelectorAll('button, a'), function (el) { el.tabIndex = active ? 0 : -1; });
        });
        this.flipBtns.forEach(function (btn) { btn.setAttribute('aria-pressed', flipped ? 'true' : 'false'); });
      }
      _toggleFlip() {
        var self = this;
        this.flipped = !this.flipped;
        this._applyFaces();
        window.requestAnimationFrame(function () {
          var face = self.flipped ? self.back : self.front;
          var btn = face && face.querySelector('[data-arc-flip-btn]');
          if (btn) btn.focus();
        });
      }
    }
    customElements.define('fleeta-agent-receipt', FleetaAgentReceipt);
  })();

/* <fleeta-bf-landing> — Black Friday 랜딩(sections/fleeta-black-friday.liquid). 진입 즉시 코드 화면(10/27 사양: 시리얼 입력·시트 저장 삭제).
   Apply(hero): 코드 복사(clipboard → execCommand 폴백) + <a target=_blank> 기본 동작으로 새 탭(복사 실패해도 이동).
   GA4: dataLayer 'fleeta_bf_apply_click'{position}. data-cta-label 미사용(fleeta_cta_click 이중 발화 방지). */
(function () {
  if (customElements.get('fleeta-bf-landing')) return;

  function track(payload) { (window.dataLayer = window.dataLayer || []).push(payload); }
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).catch(function () { fallbackCopy(text); });
    } else {
      fallbackCopy(text);
    }
  }

  class FleetaBfLanding extends HTMLElement {
    connectedCallback() {
      this.code = this.getAttribute('data-code') || '';
      this.appliedLabel = this.getAttribute('data-applied-label') || 'Copied';
      this.status = this.querySelector('[data-bf-status]');
      this.applyBtns = Array.prototype.slice.call(this.querySelectorAll('[data-bf-apply]'));
      this._onClick = this._click.bind(this);
      this.addEventListener('click', this._onClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      window.clearTimeout(this._labelTimer);
    }
    _click(e) {
      var apply = e.target.closest && e.target.closest('[data-bf-apply]');
      if (!apply || !this.contains(apply)) return;
      // 기본 동작(target=_blank 새 탭)은 막지 않는다 — 팝업 차단 회피, 복사 실패해도 이동
      copyText(this.code);
      this._flashApplied();
      if (this.status) this.status.classList.add('is-on');
      track({ event: 'fleeta_bf_apply_click', position: apply.getAttribute('data-position') || '' });
    }
    _flashApplied() {
      var label = this.appliedLabel;
      this.applyBtns.forEach(function (btn) {
        if (btn.__bfOrig == null) btn.__bfOrig = btn.textContent;
        btn.textContent = label;
        btn.classList.add('is-done');
      });
      window.clearTimeout(this._labelTimer);
      var btns = this.applyBtns;
      this._labelTimer = window.setTimeout(function () {
        btns.forEach(function (btn) {
          btn.textContent = btn.__bfOrig;
          btn.__bfOrig = null;
          btn.classList.remove('is-done');
        });
      }, 2600);
    }
  }
  customElements.define('fleeta-bf-landing', FleetaBfLanding);
})();
